import * as React from "react";
const WeddingInvitaionSVG = (props) => (
  <svg
    className="animated"
    id="freepik_stories-wedding"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 500 500"
    xmlnsXlink="http://www.w3.org/1999/xlink"

    {...props}
  >
    <style>
      {
        "svg#freepik_stories-wedding:not(.animated) .animable {opacity: 0;}svg#freepik_stories-wedding.animated #freepik--Grass--inject-63 {animation: 1s 1 forwards cubic-bezier(.36,-0.01,.5,1.38) fadeIn,1.5s Infinite  linear floating;animation-delay: 0s,1s;}svg#freepik_stories-wedding.animated #freepik--Shadows--inject-63 {animation: 1s 1 forwards cubic-bezier(.36,-0.01,.5,1.38) fadeIn;animation-delay: 0s;}svg#freepik_stories-wedding.animated #freepik--Plants--inject-63 {animation: 1s 1 forwards cubic-bezier(.36,-0.01,.5,1.38) slideUp,1.5s Infinite  linear wind;animation-delay: 0s,1s;}svg#freepik_stories-wedding.animated #freepik--Characters--inject-63 {animation: 1s 1 forwards cubic-bezier(.36,-0.01,.5,1.38) lightSpeedLeft;animation-delay: 0s;}svg#freepik_stories-wedding.animated #freepik--Hearts--inject-63 {animation: 1s 1 forwards cubic-bezier(.36,-0.01,.5,1.38) lightSpeedRight,6s Infinite  linear shake;animation-delay: 0s,1s;}            @keyframes fadeIn {                0% {                    opacity: 0;                }                100% {                    opacity: 1;                }            }                    @keyframes floating {                0% {                    opacity: 1;                    transform: translateY(0px);                }                50% {                    transform: translateY(-10px);                }                100% {                    opacity: 1;                    transform: translateY(0px);                }            }                    @keyframes slideUp {                0% {                    opacity: 0;                    transform: translateY(30px);                }                100% {                    opacity: 1;                    transform: inherit;                }            }                    @keyframes wind {                0% {                    transform: rotate( 0deg );                }                25% {                    transform: rotate( 1deg );                }                75% {                    transform: rotate( -1deg );                }            }                    @keyframes lightSpeedLeft {              from {                transform: translate3d(-50%, 0, 0) skewX(20deg);                opacity: 0;              }              60% {                transform: skewX(-10deg);                opacity: 1;              }              80% {                transform: skewX(2deg);              }              to {                opacity: 1;                transform: translate3d(0, 0, 0);              }            }                    @keyframes lightSpeedRight {              from {                transform: translate3d(50%, 0, 0) skewX(-20deg);                opacity: 0;              }              60% {                transform: skewX(10deg);                opacity: 1;              }              80% {                transform: skewX(-2deg);              }              to {                opacity: 1;                transform: translate3d(0, 0, 0);              }            }                    @keyframes shake {                10%, 90% {                    transform: translate3d(-1px, 0, 0);                  }                  20%, 80% {                    transform: translate3d(2px, 0, 0);                  }                  30%, 50%, 70% {                    transform: translate3d(-4px, 0, 0);                  }                  40%, 60% {                    transform: translate3d(4px, 0, 0);                  }            }        "
      }
    </style>
    <g
      id="freepik--Grass--inject-63"
      className="animable"
      style={{
        transformOrigin: "245.58px 386.15px",
      }}
    >
      <ellipse
        id="freepik--Floor--inject-63"
        cx={245.58}
        cy={386.15}
        rx={186.24}
        ry={98.53}
        style={{
          fill: "#213E60",
          transformOrigin: "245.58px 386.15px",
        }}
        className="animable"
      />
    </g>
    <g
      id="freepik--Shadows--inject-63"
      className="animable"
      style={{
        transformOrigin: "238.202px 384.353px",
      }}
    >
      <g id="freepik--Shadow--inject-63">
        <path
          d="M357.6,366.87c-18.32-10.57-45.63-12.78-67.71-6.63A69.85,69.85,0,0,0,270.17,344c-38.6-22.29-101.18-22.29-139.78,0s-38.61,58.42,0,80.71,101.18,22.28,139.78,0a84.36,84.36,0,0,0,9.55-6.4c23.25,10.25,56.62,9.25,77.87-3C380.76,401.92,380.76,380.24,357.6,366.87Z"
          style={{
            opacity: 0.1,
            transformOrigin: "238.202px 384.353px",
          }}
          className="animable"
          id="elxikwrtcntwp"
        />
      </g>
    </g>
    <g
      id="freepik--Plants--inject-63"
      className="animable"
      style={{
        transformOrigin: "252.107px 284.126px",
      }}
    >
      <g
        id="freepik--plants--inject-63"
        className="animable"
        style={{
          transformOrigin: "384.652px 330.129px",
        }}
      >
        <g
          id="freepik--Plant--inject-63"
          className="animable"
          style={{
            transformOrigin: "373.448px 321.106px",
          }}
        >
          <path
            d="M341.27,338.71a40.88,40.88,0,0,0,1.59,4.8c1.8,4.57,4.08,9,4.71,13.91.29,2.26.25,4.68,1.4,6.65,2.66,4.54,5.73,1.2,7.53-1.57,4.39-6.75,8.72-13.25,16.23-16.71,3.73-1.72,7.68-3.06,11-5.47s6-6.24,5.64-10.33c-.2-2.46-1.45-4.82-1.19-7.27.34-3.07,3-5.39,5.74-6.77s5.83-2.16,8.4-3.87,4.64-4.78,3.86-7.77c-1.11-4.24-7.17-6.08-7.47-10.45-.32-4.74,6.55-7.76,6-12.48-1-8.62-13.67-5.11-18.21-2.53-4,2.27-7.73,5.19-12.1,6.67-5.52,1.87-12.25,1.58-16.16,5.9-4.47,4.92-2.55,12.8-4.81,19.05-2.56,7.07-10.27,11.46-12.33,18.69A18.33,18.33,0,0,0,341.27,338.71Z"
            style={{
              fill: "#213E60",
              transformOrigin: "373.448px 321.106px",
            }}
            id="elxyc6gvn75c"
            className="animable"
          />
          <g id="elr3zmkxfy69">
            <path
              d="M341.27,338.71a40.88,40.88,0,0,0,1.59,4.8c1.8,4.57,4.08,9,4.71,13.91.29,2.26.25,4.68,1.4,6.65,2.66,4.54,5.73,1.2,7.53-1.57,4.39-6.75,8.72-13.25,16.23-16.71,3.73-1.72,7.68-3.06,11-5.47s6-6.24,5.64-10.33c-.2-2.46-1.45-4.82-1.19-7.27.34-3.07,3-5.39,5.74-6.77s5.83-2.16,8.4-3.87,4.64-4.78,3.86-7.77c-1.11-4.24-7.17-6.08-7.47-10.45-.32-4.74,6.55-7.76,6-12.48-1-8.62-13.67-5.11-18.21-2.53-4,2.27-7.73,5.19-12.1,6.67-5.52,1.87-12.25,1.58-16.16,5.9-4.47,4.92-2.55,12.8-4.81,19.05-2.56,7.07-10.27,11.46-12.33,18.69A18.33,18.33,0,0,0,341.27,338.71Z"
              style={{
                opacity: 0.3,
                transformOrigin: "373.448px 321.106px",
              }}
              className="animable"
              id="elhogeszacr19"
            />
          </g>
          <path
            d="M350.52,357.66h0a.63.63,0,0,1-.6-.68c2.28-35.63,28.89-66.55,42.63-75.19a.64.64,0,0,1,.68,1.08c-13.55,8.52-39.78,39-42,74.19A.65.65,0,0,1,350.52,357.66Z"
            style={{
              fill: "rgb(255, 255, 255)",
              transformOrigin: "371.703px 319.69px",
            }}
            id="el1orwvvdihkc"
            className="animable"
          />
        </g>
        <g
          id="freepik--plant--inject-63"
          className="animable"
          style={{
            transformOrigin: "390.963px 348.849px",
          }}
        >
          <path
            d="M356,384.35c7.65-26.88,35.13-39.67,60.3-47.39,15.18-4.65,14.21-16.63,9-20.57-8-6-31.59-3.43-48.57,10.47s-23.41,34.61-23.56,49.64Z"
            style={{
              fill: "#213E60",
              transformOrigin: "390.963px 348.849px",
            }}
            id="el2f15zoj21wm"
            className="animable"
          />
          <g id="elqf31ra93rj">
            <path
              d="M356,384.35c7.65-26.88,35.13-39.67,60.3-47.39,15.18-4.65,14.21-16.63,9-20.57-8-6-31.59-3.43-48.57,10.47s-23.41,34.61-23.56,49.64Z"
              style={{
                opacity: 0.2,
                transformOrigin: "390.963px 348.849px",
              }}
              className="animable"
              id="elkho6h6rzlfs"
            />
          </g>
          <path
            d="M355.33,373.57l-.18,0a.64.64,0,0,1-.44-.79C364.67,337,399.65,319,416.43,319a.64.64,0,1,1,0,1.28c-16.43,0-50.7,17.63-60.49,52.78A.64.64,0,0,1,355.33,373.57Z"
            style={{
              fill: "rgb(255, 255, 255)",
              transformOrigin: "385.878px 346.285px",
            }}
            id="el9yqy6e31hzt"
            className="animable"
          />
        </g>
      </g>
      <g
        id="freepik--plant--inject-63"
        className="animable"
        style={{
          transformOrigin: "118.951px 258.133px",
        }}
      >
        <path
          d="M127.09,332.32l.07,0a.8.8,0,0,0,1-.45c14-35.52,17.49-97.94-18.53-125.55a.8.8,0,1,0-1,1.27c35.36,27.1,31.83,88.64,18,123.69A.81.81,0,0,0,127.09,332.32Z"
          style={{
            fill: "#213E60",
            transformOrigin: "123.205px 269.255px",
          }}
          id="elvjwkluzli3n"
          className="animable"
        />
        <path
          d="M118.91,260.1a6.47,6.47,0,0,1-3.09-7.29c.83-2.71,3.58-4.12,7.36-3.78,8.81.8,13.66,11.91,14.19,17.4l.21,2.21L136,267.07c-3.43-3.41-7.2-4.22-10.85-5a24.07,24.07,0,0,1-5.91-1.79Zm16.46,4.3c-1.29-5-5.41-13.15-12.33-13.77-3-.28-5.09.69-5.69,2.65a4.89,4.89,0,0,0,2.33,5.41,20.93,20.93,0,0,0,5.81,1.81,29.18,29.18,0,0,1,7.3,2.29A17.13,17.13,0,0,1,135.37,264.4Z"
          style={{
            fill: "#213E60",
            transformOrigin: "126.593px 258.81px",
          }}
          id="elegz5octath"
          className="animable"
        />
        <path
          d="M136.33,267a.5.5,0,0,0,.38,0,.54.54,0,0,0,.38-.65c-1.42-5.29-9-11.62-15-12.54a.54.54,0,1,0-.16,1.06c6.17.94,12.93,7.25,14.14,11.76A.5.5,0,0,0,136.33,267Z"
          style={{
            fill: "#213E60",
            transformOrigin: "129.256px 260.414px",
          }}
          id="eli1vh582n4oa"
          className="animable"
        />
        <path
          d="M105.54,226.9c.06-2.83,2.33-4.94,6.06-5.63C120.3,219.65,128,229,130,234.18l.8,2.07-1.94-1.08c-4.21-2.34-8.07-2.12-11.8-1.88a22.55,22.55,0,0,1-6.54-.21,5.43,5.43,0,0,1-1.38-.51A6.4,6.4,0,0,1,105.54,226.9Zm6.35-4.06c-3,.56-4.71,2-4.75,4.1a4.88,4.88,0,0,0,3.71,4.58,21.78,21.78,0,0,0,6.08.17c3.19-.2,6.74-.43,10.56,1.07C124.89,228.25,118.73,221.57,111.89,222.84Z"
          style={{
            fill: "#213E60",
            transformOrigin: "118.17px 228.667px",
          }}
          id="el5pfmnecoh5w"
          className="animable"
        />
        <path
          d="M111.66,227.2a.63.63,0,0,0,.31.05c6.19-.76,14.41,3.48,16.79,7.49a.55.55,0,0,0,.73.19.54.54,0,0,0,.19-.74c-2.79-4.71-11.8-8.74-17.84-8a.54.54,0,0,0-.47.6A.57.57,0,0,0,111.66,227.2Z"
          style={{
            fill: "#213E60",
            transformOrigin: "120.561px 230.55px",
          }}
          id="elqfl5ksp5gp8"
          className="animable"
        />
        <path
          d="M144.12,236.05a5.09,5.09,0,0,1,5.73.36,6,6,0,0,1,2.49,5.3,9.72,9.72,0,0,1-4.94,7.14c-5,2.92-10.5,7.42-10.7,10l-1.6,0C134.64,247.11,139.29,238.5,144.12,236.05Zm.73,1.43c-3.81,1.93-7.64,8.66-8.13,17.84,3.09-3.9,9.53-7.66,9.88-7.86a8.16,8.16,0,0,0,4.14-5.86,4.43,4.43,0,0,0-1.89-3.93,3,3,0,0,0-.59-.38A3.71,3.71,0,0,0,144.85,237.48Z"
          style={{
            fill: "#213E60",
            transformOrigin: "143.712px 247.092px",
          }}
          id="elvfcwzycpzut"
          className="animable"
        />
        <path
          d="M135.66,259.28l.18.05a.53.53,0,0,0,.59-.47c.93-8.14,7.69-16.24,10.1-17.94a.53.53,0,1,0-.62-.87c-2.52,1.78-9.57,10.22-10.54,18.69A.55.55,0,0,0,135.66,259.28Z"
          style={{
            fill: "#213E60",
            transformOrigin: "141.061px 249.642px",
          }}
          id="elbk69z5pz52j"
          className="animable"
        />
        <path
          d="M130.61,206.38a5.12,5.12,0,0,1,5.69-.72,6,6,0,0,1,3.44,4.74,9.73,9.73,0,0,1-3.51,7.94c-4.41,3.81-8.93,9.26-8.63,11.84l-1.58.27C123.37,219,126.32,209.7,130.61,206.38Zm1,1.27c-3.38,2.61-5.89,9.94-4.63,19,2.3-4.41,7.91-9.31,8.22-9.57a8.2,8.2,0,0,0,3-6.54,4.46,4.46,0,0,0-2.59-3.51l-.05,0A3.57,3.57,0,0,0,131.59,207.65Z"
          style={{
            fill: "#213E60",
            transformOrigin: "132.382px 217.779px",
          }}
          id="elfa3rh9yiz7i"
          className="animable"
        />
        <path
          d="M126.56,230.75a.52.52,0,0,0,.28.05.54.54,0,0,0,.49-.57c-.61-8.17,4.51-17.39,6.56-19.52a.53.53,0,0,0,0-.75.53.53,0,0,0-.75,0c-2.14,2.22-7.49,11.84-6.85,20.34A.53.53,0,0,0,126.56,230.75Z"
          style={{
            fill: "#213E60",
            transformOrigin: "130.141px 220.304px",
          }}
          id="elpez6k0tdjmh"
          className="animable"
        />
        <g id="el645zevq7ocx">
          <path
            d="M149.85,236.41a5.09,5.09,0,0,0-5.73-.36c-3.71,1.88-7.3,7.41-8.57,15.18a90.12,90.12,0,0,0-7.71-22.58c1-2.85,4.73-7.14,8.39-10.31a9.73,9.73,0,0,0,3.51-7.94,6,6,0,0,0-3.44-4.74,5.12,5.12,0,0,0-5.69.72c-3.41,2.63-6,9.07-5.54,17.33a62.62,62.62,0,0,0-15.4-17.36.8.8,0,1,0-1,1.27,62.15,62.15,0,0,1,16.41,19.27c-3.47-3.63-8.3-6.59-13.5-5.62-3.73.69-6,2.8-6.06,5.63a6.4,6.4,0,0,0,3.57,5.67,5.43,5.43,0,0,0,1.38.51,22.55,22.55,0,0,0,6.54.21c3.73-.24,7.59-.46,11.8,1.88l.3.16a97.69,97.69,0,0,1,6,22c0,.48,0,1,0,1.45h.19c0,.27.07.54.11.81-2.25-5-6.35-10.08-12.22-10.61-3.78-.34-6.53,1.07-7.36,3.78a6.47,6.47,0,0,0,3.09,7.29l.34.18a24.07,24.07,0,0,0,5.91,1.79c3.65.78,7.42,1.59,10.85,5l.18.18c1.65,22.92-2.65,46.73-9.48,64.06a.81.81,0,0,0,.38,1l.07,0a.8.8,0,0,0,1-.45c7.78-19.74,12.3-47.8,8.61-73.57.79-2.64,5.88-6.75,10.59-9.48a9.72,9.72,0,0,0,4.94-7.14A6,6,0,0,0,149.85,236.41Zm-18.26-28.76a3.57,3.57,0,0,1,3.92-.59l.05,0a4.46,4.46,0,0,1,2.59,3.51,8.23,8.23,0,0,1-3,6.54,45.29,45.29,0,0,0-7.66,8.6c1-6.78,4.69-13.28,6.36-15a.53.53,0,0,0-.76-.74c-1.64,1.7-5.12,7.69-6.41,14.21C126.2,216.25,128.53,210,131.59,207.65Zm-14.66,24a21.78,21.78,0,0,1-6.08-.17,4.88,4.88,0,0,1-3.71-4.58c0-2.05,1.78-3.54,4.75-4.1,5.7-1.06,10.92,3.41,14,7.53-4-2.82-9.77-4.71-14.06-4.18a.54.54,0,0,0-.47.6.57.57,0,0,0,.29.41.63.63,0,0,0,.31.05c5.08-.62,11.5,2.11,15,5.32C123.33,231.3,120,231.5,116.93,231.69Zm8.56,28.81a20.93,20.93,0,0,1-5.81-1.81,4.89,4.89,0,0,1-2.33-5.41c.6-2,2.67-2.93,5.69-2.65,5.77.52,9.58,6.23,11.44,11-3.08-3.8-8.12-7.18-12.4-7.84a.54.54,0,1,0-.16,1.06c5,.77,10.5,5.15,13,9.18a16.62,16.62,0,0,0-2.1-1.28A29.18,29.18,0,0,0,125.49,260.5Zm25.25-18.9a8.16,8.16,0,0,1-4.14,5.86,45.28,45.28,0,0,0-9.14,7c2.22-6.48,7.1-12.16,9.07-13.55a.53.53,0,1,0-.62-.87c-1.92,1.35-6.47,6.59-8.95,12.75,1-7.88,4.44-13.57,7.89-15.32a3.71,3.71,0,0,1,3.41-.19,3,3,0,0,1,.59.38A4.43,4.43,0,0,1,150.74,241.6Z"
            style={{
              opacity: 0.4,
              transformOrigin: "128.92px 268.706px",
            }}
            className="animable"
            id="eleetch3o4cbe"
          />
        </g>
        <path
          d="M97.7,211a20.42,20.42,0,0,0,9.17-5.64c4-4.63,5.35-11.89,4.14-17.83a5.4,5.4,0,0,0-1.37-2.93,2.28,2.28,0,0,0-3-.25,3.51,3.51,0,0,0-.82,2.33c-.25,2.51-.49,5-.73,7.54a16.37,16.37,0,0,0-2.89-7.84c-.59-.85-1.53-1.72-2.52-1.41-1.17.36-1.25,2-1,3.19a29,29,0,0,0,3.24,8.91,32,32,0,0,0-9.19-4.39,2.19,2.19,0,0,0-2,.08c-.93.74-.22,2.22.59,3.08A20.62,20.62,0,0,0,98,200.5a24.23,24.23,0,0,0-10.88.29,2.13,2.13,0,0,0-1.43.84c-.55,1,.59,2.07,1.62,2.53a20,20,0,0,0,8.83,1.59c-1.88.57-6.07,2.35-5.86,4S94.63,211.71,97.7,211Z"
          style={{
            fill: "#213E60",
            transformOrigin: "98.4923px 197.63px",
          }}
          id="el21rfbzxzw8s"
          className="animable"
        />
      </g>
      <g
        id="freepik--plants--inject-63"
        className="animable"
        style={{
          transformOrigin: "102.806px 322.51px",
        }}
      >
        <path
          d="M126.24,354.21c.19-1.31,7.82-32.35,1.25-54.72-8.12-27.67-20-34.63-30.06-28.93-9,5.13-2.64,17.48,5.61,30.65,9.78,15.62,15.56,31.66,13.84,49.6Z"
          style={{
            fill: "rgb(55, 71, 79)",
            transformOrigin: "111.6px 311.464px",
          }}
          id="el5mpmbj1y12"
          className="animable"
        />
        <path
          d="M121.1,350.16a.69.69,0,0,1-.51-.81c7.16-37-12.42-66.88-18.06-72.85a.69.69,0,1,1,1-.95c5.74,6.08,25.68,36.5,18.41,74.07a.71.71,0,0,1-.81.55Z"
          style={{
            fill: "rgb(255, 255, 255)",
            transformOrigin: "112.92px 312.749px",
          }}
          id="elj6zd5y3yacl"
          className="animable"
        />
        <path
          d="M93.52,372.65c-.89-.39-1.77-.8-2.63-1.21-2.87-1.39-5.8-3-7.55-5.68s-1.88-6.65.52-8.74c1.2-1,2.87-1.52,3.89-2.74,1.49-1.78,1-4.58-.36-6.46s-3.43-3.1-5.31-4.47a16.59,16.59,0,0,1-6-7.08c-1.13-2.94-.77-6.61,1.52-8.77,1.65-1.55,4.22-2.36,4.9-4.52s-.76-4.1-1.55-5.85c-1-2.25-2.3-4.39-2.73-6.87a7.71,7.71,0,0,1,1.92-6.93,8.82,8.82,0,0,1,5.66-1.95,23.13,23.13,0,0,1,12,3.11,42.79,42.79,0,0,1,9.81,7.83,58,58,0,0,1,13.21,20.37A41.67,41.67,0,0,1,123.3,350a62.93,62.93,0,0,1-3.81,18.19c-1.56,3.9-3.41,7.37-8,7.93C105.29,376.89,99.15,375.11,93.52,372.65Z"
          style={{
            fill: "rgb(69, 90, 100)",
            transformOrigin: "99.4294px 338.839px",
          }}
          id="el1kq08vjhsij"
          className="animable"
        />
        <path
          d="M115.16,372.21a.41.41,0,0,0,.19,0,.59.59,0,0,0,.59-.6c-.07-43.6-27.81-63.49-28.09-63.68a.58.58,0,0,0-.82.14.59.59,0,0,0,.15.82c7.65,5.35,27.52,27,27.58,62.73A.59.59,0,0,0,115.16,372.21Z"
          style={{
            fill: "rgb(250, 250, 250)",
            transformOrigin: "101.433px 340.02px",
          }}
          id="el8i4c7pz69hc"
          className="animable"
        />
        <path
          d="M110.68,343.87a.61.61,0,0,0,.54-.08.59.59,0,0,0,.14-.83c-6.12-8.5-20-11.94-27.88-11.67a.59.59,0,0,0-.57.61.61.61,0,0,0,.61.57c7.63-.27,21,3,26.88,11.18A.54.54,0,0,0,110.68,343.87Z"
          style={{
            fill: "rgb(250, 250, 250)",
            transformOrigin: "97.191px 337.588px",
          }}
          id="elo33967n8vi"
          className="animable"
        />
      </g>
      <g
        id="freepik--plant--inject-63"
        className="animable"
        style={{
          transformOrigin: "383.379px 265.203px",
        }}
      >
        <path
          d="M346.56,332.42h-.08a.8.8,0,0,1-.87-.72c-3.5-38,10.6-98.93,52.9-115.36a.8.8,0,1,1,.58,1.49c-41.53,16.13-55.34,76.21-51.88,113.72A.8.8,0,0,1,346.56,332.42Z"
          style={{
            fill: "rgb(69, 90, 100)",
            transformOrigin: "372.363px 274.349px",
          }}
          id="elshjsy5qqzuf"
          className="animable"
        />
        <path
          d="M400.71,205.93a12.19,12.19,0,0,1,3.25-6.82,3.17,3.17,0,0,1,2.76-1.11,2.58,2.58,0,0,1,1.73,2.59,7.61,7.61,0,0,1-1,3.17,11.65,11.65,0,0,1,5-3.65,2.85,2.85,0,0,1,2.4-.07,2.34,2.34,0,0,1,.95,2.11c0,2-2.93,6.22-4.33,7.6-3.51.9-5.28,2.17-8.29,4.29-1.4,1-2.39-.08-2.67-1.95A20.86,20.86,0,0,1,400.71,205.93Z"
          style={{
            fill: "#213E60",
            transformOrigin: "408.09px 206.202px",
          }}
          id="elxulcd5jab39"
          className="animable"
        />
        <path
          d="M408.62,212.15a12.16,12.16,0,0,1,7.43-1.36,3.16,3.16,0,0,1,2.52,1.58,2.58,2.58,0,0,1-1.08,2.92,7.72,7.72,0,0,1-3.16,1,11.63,11.63,0,0,1,5.87,1.89,2.8,2.8,0,0,1,1.46,1.9,2.36,2.36,0,0,1-1.15,2c-1.61,1.13-3.76,1.06-5.7.73a27.22,27.22,0,0,1-10.68-4.3c-1.42-1-2-1.67-.64-3A20.94,20.94,0,0,1,408.62,212.15Z"
          style={{
            fill: "#213E60",
            transformOrigin: "412.189px 216.851px",
          }}
          id="elugkwvpa563"
          className="animable"
        />
        <path
          d="M399.53,211.92s-5.89-5.13-4.4-10,5.58-1.14,5.58-1.14A20.51,20.51,0,0,0,399.53,211.92Z"
          style={{
            fill: "#213E60",
            transformOrigin: "397.799px 205.667px",
          }}
          id="elnfh1n29avt"
          className="animable"
        />
        <path
          d="M403,219c.84,1.28,6.28,4.86,10.57,5.13a3.59,3.59,0,0,1-.1,4.53C411.5,230.81,403.68,227.21,403,219Z"
          style={{
            fill: "#213E60",
            transformOrigin: "408.663px 224.135px",
          }}
          id="eldjjivm3502"
          className="animable"
        />
        <path
          d="M374.23,265.45a24.41,24.41,0,0,1-6.17.07c-3.72-.27-7.57-.55-11.82,1.77l-1.95,1.06.82-2.06c2.05-5.13,9.81-14.44,18.49-12.74,3.73.73,6,2.86,6,5.69a6.45,6.45,0,0,1-5,6.13Zm-13.71-1.37a28.7,28.7,0,0,1,7.65-.16,21.2,21.2,0,0,0,6.09-.11,4.89,4.89,0,0,0,3.75-4.55c0-2.05-1.74-3.55-4.72-4.14-6.82-1.33-13,5.29-15.69,9.78A17.15,17.15,0,0,1,360.52,264.08Z"
          style={{
            fill: "rgb(69, 90, 100)",
            transformOrigin: "366.945px 260.848px",
          }}
          id="el5o3xxsyilg"
          className="animable"
        />
        <path
          d="M356,267.11a.57.57,0,0,1-.38-.07.53.53,0,0,1-.18-.73c2.84-4.68,11.88-8.64,17.92-7.84a.53.53,0,1,1-.14,1.06c-6.19-.82-14.45,3.34-16.86,7.33A.56.56,0,0,1,356,267.11Z"
          style={{
            fill: "rgb(69, 90, 100)",
            transformOrigin: "364.595px 262.742px",
          }}
          id="el47pp14qknka"
          className="animable"
        />
        <path
          d="M391.72,241.69a6,6,0,0,1-1.47.09,22.21,22.21,0,0,1-6.34-1.63c-3.51-1.26-7.15-2.56-11.85-1.49l-2.17.5,1.35-1.77c3.35-4.38,13.34-11.24,21.24-7.26,3.4,1.72,5,4.37,4.25,7.11A6.42,6.42,0,0,1,391.72,241.69Zm-17.71-5c4.09-.38,7.44.83,10.44,1.92a21.56,21.56,0,0,0,5.89,1.53,4.87,4.87,0,0,0,4.84-3.35c.53-2-.72-3.9-3.42-5.26C385.56,228.43,377.78,233.12,374,236.73Z"
          style={{
            fill: "rgb(69, 90, 100)",
            transformOrigin: "383.401px 235.362px",
          }}
          id="elba2mnbl23zp"
          className="animable"
        />
        <path
          d="M390.77,235.81a.48.48,0,0,1-.31,0c-5.74-2.46-14.81-.69-18.22,2.5a.53.53,0,0,1-.73-.78c4-3.74,13.78-5.1,19.37-2.7a.54.54,0,0,1-.11,1Z"
          style={{
            fill: "rgb(69, 90, 100)",
            transformOrigin: "381.256px 236.042px",
          }}
          id="elqg484j7q2cg"
          className="animable"
        />
        <path
          d="M359.42,259.63l-1.55-.42c.54-2.54-3.45-8.39-7.47-12.61a9.72,9.72,0,0,1-2.75-8.23,6,6,0,0,1,3.88-4.39,5.06,5.06,0,0,1,5.6,1.25C361.08,238.94,363.13,248.51,359.42,259.63Zm-6.61-24.37a3.72,3.72,0,0,0-.68.2,4.45,4.45,0,0,0-2.91,3.25,8.16,8.16,0,0,0,2.34,6.79c.28.29,5.4,5.7,7.28,10.3,2.11-9,.3-16.48-2.81-19.4A3.75,3.75,0,0,0,352.81,235.26Z"
          style={{
            fill: "rgb(69, 90, 100)",
            transformOrigin: "354.461px 246.621px",
          }}
          id="elxfutpn8c2x"
          className="animable"
        />
        <path
          d="M358.76,259.9a.6.6,0,0,1-.19,0,.54.54,0,0,1-.44-.62c1.39-8.07-2.84-17.74-4.68-20a.53.53,0,1,1,.84-.66c1.92,2.41,6.33,12.5,4.89,20.89A.53.53,0,0,1,358.76,259.9Z"
          style={{
            fill: "rgb(69, 90, 100)",
            transformOrigin: "356.4px 249.162px",
          }}
          id="elpvfagwume9"
          className="animable"
        />
        <path
          d="M376.07,234.92l-1.44-.7c1-2.4-1.81-8.89-5-13.79a9.72,9.72,0,0,1-1.15-8.6,6,6,0,0,1,4.63-3.58,5.09,5.09,0,0,1,5.26,2.28C381.59,214.91,381.81,224.69,376.07,234.92Zm-2.57-25.11h-.05a4.45,4.45,0,0,0-3.47,2.64,8.2,8.2,0,0,0,1,7.11c.22.34,4.24,6.61,5.22,11.49,3.75-8.4,3.4-16.14.88-19.59A3.56,3.56,0,0,0,373.5,209.81Z"
          style={{
            fill: "rgb(69, 90, 100)",
            transformOrigin: "374.291px 221.54px",
          }}
          id="elj2v26h9d7u"
          className="animable"
        />
        <path
          d="M375.47,235.05a.53.53,0,0,1-.6-.71c2.88-7.67.54-18-.83-20.57a.53.53,0,0,1,.22-.72.54.54,0,0,1,.73.22c1.43,2.73,3.88,13.47.88,21.44A.5.5,0,0,1,375.47,235.05Z"
          style={{
            fill: "rgb(69, 90, 100)",
            transformOrigin: "375.636px 224.023px",
          }}
          id="elajutjjjiocb"
          className="animable"
        />
      </g>
    </g>
    <g
      id="freepik--Characters--inject-63"
      className="animable"
      style={{
        transformOrigin: "236.527px 228.105px",
      }}
    >
      <g
        id="freepik--Groom--inject-63"
        className="animable"
        style={{
          transformOrigin: "298.722px 218.703px",
        }}
      >
        <polygon
          points="294.44 381.02 288.29 379.06 290.06 374.87 293.95 378.14 294.44 381.02"
          id="elgkolxmsacj5"
          className="animable"
          style={{
            transformOrigin: "291.365px 377.945px",
          }}
        />
        <path
          d="M300.14,369.82s.43,3.92.55,5.16-5,5.34-6.25,6l-.49-2.89c-1.08,1.19-1.68,2.67-2.8,4.84-.92,1.82-2,5.23-4.73,7.64-4,3.59-10.36,5.62-16.94,6.19s-10.44-.86-12.39-2.2-2.62-3-2.24-4.68S300.14,369.82,300.14,369.82Z"
          style={{
            fill: "rgb(38, 50, 56)",
            transformOrigin: "277.72px 383.354px",
          }}
          id="eltusqn9ww33"
          className="animable"
        />
        <polygon
          points="297.18 362.15 282.13 361.39 280.41 338.24 297.39 334.06 297.18 362.15"
          style={{
            fill: "rgb(255, 168, 167)",
            transformOrigin: "288.9px 348.105px",
          }}
          id="elymfft4dxpub"
          className="animable"
        />
        <path
          d="M281.83,357.28l-.19-2.27c-1.22,0-1.2,3.33-2.83,6.32a59.4,59.4,0,0,1-8.69,12.33c-6.38,6.42-12.16,10.55-15,13.44-3.81,3.87,3.5,9.35,14.23,8.21,5.33-.56,14.68-3.72,17.19-7s3.9-8.29,5.93-10.69,6.49-4.94,7.68-7.79c.65-1.56.09-5.11-.5-8.13-.54-2.76-.83-7-2.38-6.6l0,1.44c-.59,1.25-2,3.33-6.24,4.27C288.84,361.27,282.44,361.78,281.83,357.28Z"
          style={{
            fill: "rgb(69, 90, 100)",
            transformOrigin: "277.27px 375.236px",
          }}
          id="el2oirxd9e9h9"
          className="animable"
        />
        <g id="elk25b2fc23e">
          <path
            d="M287.52,361.09c-2.06-.08-4.31-.65-5.26-2.46,0,0,0,0,0-.06a5.24,5.24,0,0,1-1.17,4.46c-1.81,2.34-13.18,18.83-13.18,18.83s10.66-13.66,12.71-16.24c3-3.8,4-4.28,7-4.53Z"
            style={{
              opacity: 0.15,
              transformOrigin: "277.765px 370.215px",
            }}
            className="animable"
            id="el89nluo8ng0a"
          />
        </g>
        <path
          d="M255.11,387.1c2.41-2.44,6.9-5.77,12.09-10.62-1.06,1.88-2.65,3.38-2.79,4-.35,1.51,4.18,3.37,6.91,3.95s5.59-3.44,9.39-7.13,7.51.22,9.1,5a32.33,32.33,0,0,1-3.28,6c-2.51,3.29-11.86,6.45-17.19,7C258.61,396.45,251.3,391,255.11,387.1Z"
          style={{
            fill: "rgb(55, 71, 79)",
            transformOrigin: "271.949px 385.648px",
          }}
          id="elt19zrzjkx0c"
          className="animable"
        />
        <g id="el6e9dgp3usz5">
          <path
            d="M285.05,365.43a.66.66,0,1,0,1.3-.21.67.67,0,0,0-.76-.55A.66.66,0,0,0,285.05,365.43Z"
            style={{
              opacity: 0.15,
              transformOrigin: "285.704px 365.346px",
            }}
            className="animable"
            id="elarcl7nogd8v"
          />
        </g>
        <g id="el9uv4g05fs4j">
          <path
            d="M282.05,369.1a.64.64,0,0,0,.75.54.66.66,0,0,0,.55-.75.67.67,0,0,0-.76-.55A.66.66,0,0,0,282.05,369.1Z"
            style={{
              opacity: 0.15,
              transformOrigin: "282.699px 368.992px",
            }}
            className="animable"
            id="el7fwz2luk1or"
          />
        </g>
        <g id="elfidm01hxci">
          <path
            d="M279,372.77a.66.66,0,0,0,.76.54.64.64,0,0,0,.54-.75.65.65,0,0,0-.75-.55A.67.67,0,0,0,279,372.77Z"
            style={{
              opacity: 0.15,
              transformOrigin: "279.652px 372.66px",
            }}
            className="animable"
            id="elsio0s8svwvk"
          />
        </g>
        <g id="elr7x35p1fv1d">
          <path
            d="M276,376.44a.66.66,0,0,0,.76.54.66.66,0,0,0-.21-1.3A.67.67,0,0,0,276,376.44Z"
            style={{
              opacity: 0.15,
              transformOrigin: "276.631px 376.333px",
            }}
            className="animable"
            id="ellmtwloqy9lk"
          />
        </g>
        <g id="el5us97r2hmxt">
          <path
            d="M273,380.11a.66.66,0,0,0,.76.54.65.65,0,0,0,.54-.75.66.66,0,0,0-.75-.55A.67.67,0,0,0,273,380.11Z"
            style={{
              opacity: 0.15,
              transformOrigin: "273.651px 380.001px",
            }}
            className="animable"
            id="elgsaaxi4ow7r"
          />
        </g>
        <path
          d="M285.73,365.59a.32.32,0,0,0,.17-.09.27.27,0,0,0,0-.37c-.14-.13-3.45-3-7.58-2.58h0a.27.27,0,0,0-.23.29.27.27,0,0,0,.29.24c3.9-.42,7.15,2.42,7.18,2.44A.25.25,0,0,0,285.73,365.59Z"
          style={{
            fill: "rgb(38, 50, 56)",
            transformOrigin: "282.031px 364.049px",
          }}
          id="elwfqmxh9w4h"
          className="animable"
        />
        <path
          d="M282.73,369.25a.26.26,0,0,0,.16-.09.27.27,0,0,0,0-.38c-.14-.12-3.46-3-7.59-2.57h0a.26.26,0,0,0-.23.29.26.26,0,0,0,.29.24c3.89-.42,7.15,2.41,7.18,2.44A.33.33,0,0,0,282.73,369.25Z"
          style={{
            fill: "rgb(38, 50, 56)",
            transformOrigin: "279.018px 367.708px",
          }}
          id="elg5ghhcibk8l"
          className="animable"
        />
        <path
          d="M279.73,372.93a.26.26,0,0,0,.16-.09.27.27,0,0,0,0-.38c-.14-.12-3.46-3-7.59-2.57h0a.26.26,0,0,0-.23.29.26.26,0,0,0,.29.24c3.89-.42,7.15,2.41,7.18,2.44A.28.28,0,0,0,279.73,372.93Z"
          style={{
            fill: "rgb(38, 50, 56)",
            transformOrigin: "276.018px 371.388px",
          }}
          id="elbleoowhiuic"
          className="animable"
        />
        <path
          d="M276.73,376.6a.26.26,0,0,0,.16-.09.27.27,0,0,0,0-.38c-.14-.12-3.46-3-7.59-2.57h0a.26.26,0,0,0-.23.29.26.26,0,0,0,.29.24c3.89-.42,7.15,2.41,7.18,2.44A.31.31,0,0,0,276.73,376.6Z"
          style={{
            fill: "rgb(38, 50, 56)",
            transformOrigin: "273.018px 375.058px",
          }}
          id="el24x8a010yxr"
          className="animable"
        />
        <path
          d="M273.72,380.26a.21.21,0,0,0,.17-.08.27.27,0,0,0,0-.38c-.14-.12-3.46-3-7.59-2.57h0a.27.27,0,0,0-.23.29.28.28,0,0,0,.3.24c3.89-.42,7.14,2.41,7.17,2.44A.27.27,0,0,0,273.72,380.26Z"
          style={{
            fill: "rgb(38, 50, 56)",
            transformOrigin: "270.019px 378.723px",
          }}
          id="eln690n4sjbfa"
          className="animable"
        />
        <path
          d="M269.1,170.09l27.82-15c4.93,16.83,7.25,25,7.71,33.76,1.32,24.72-4.44,75.66-4.44,75.66,1,3.26.94,14.23.32,27.26-1,20.57-.19,70-.19,70s-19,7-24.59-.8c0,0-3.41-79.3-4.92-96.92C269.17,245,269.1,170.09,269.1,170.09Z"
          style={{
            fill: "rgb(55, 71, 79)",
            transformOrigin: "286.963px 259.873px",
          }}
          id="el0hfieshrtquh"
          className="animable"
        />
        <path
          d="M276.3,217.17s-.16,41.83.24,49.1,4.18,77.28,4.18,77.28-.79-66.78-1.73-77.78S276.3,217.17,276.3,217.17Z"
          style={{
            fill: "rgb(38, 50, 56)",
            transformOrigin: "278.494px 280.36px",
          }}
          id="elxlrsoc0quw"
          className="animable"
        />
        <polygon
          points="354.75 388.54 348.32 387.93 349.15 383.47 353.65 385.82 354.75 388.54"
          id="elr9b0tozlvjp"
          className="animable"
          style={{
            transformOrigin: "351.535px 386.005px",
          }}
        />
        <path
          d="M357.91,376.37s1.27,3.73,1.65,4.91-3.71,6.3-4.81,7.25l-1.1-2.71a22.87,22.87,0,0,0-1.68,5.33c-.52,2-.89,5.55-3,8.48-3.11,4.36-8.9,7.72-15.21,9.69s-10.38,1.4-12.57.52-3.2-2.35-3.19-4.09S357.91,376.37,357.91,376.37Z"
          style={{
            fill: "rgb(38, 50, 56)",
            transformOrigin: "338.792px 393.509px",
          }}
          id="el7l7edfqk54q"
          className="animable"
        />
        <polygon
          points="353.37 369.51 338.51 372.01 331.84 349.77 347.53 342.03 353.37 369.51"
          style={{
            fill: "rgb(255, 168, 167)",
            transformOrigin: "342.605px 357.02px",
          }}
          id="elz6i038relck"
          className="animable"
        />
        <path
          d="M337.33,368.06l-.67-2.18c-1.19.29-.46,3.51-1.41,6.78a58.81,58.81,0,0,1-5.83,13.91c-4.85,7.65-9.61,12.92-11.76,16.36-2.89,4.59,5.42,8.38,15.66,5,5.08-1.7,13.53-6.8,15.28-10.55s2-8.94,3.48-11.71,5.28-6.22,5.83-9.26c.3-1.67-1-5-2.23-7.83-1.13-2.59-2.33-6.69-3.75-5.94l.27,1.41c-.3,1.35-1.21,3.68-5.18,5.52C345,370.45,338.9,372.33,337.33,368.06Z"
          style={{
            fill: "rgb(69, 90, 100)",
            transformOrigin: "337.516px 385.888px",
          }}
          id="el5eptlttv5jk"
          className="animable"
        />
        <g id="eldgypl6z1cz">
          <path
            d="M343.71,370.55c-2,.37-4.35.3-5.67-1.26l-.05-.05a5.23,5.23,0,0,1-.18,4.6c-1.27,2.68-8.82,21.23-8.82,21.23s7.47-15.64,8.92-18.6c2.13-4.36,3-5,5.81-5.92Z"
            style={{
              opacity: 0.15,
              transformOrigin: "336.355px 382.155px",
            }}
            className="animable"
            id="elimdakxdhf8"
          />
        </g>
        <path
          d="M317.66,402.93c1.82-2.91,5.49-7.12,9.51-13-.62,2.06-1.86,3.87-1.86,4.49,0,1.55,4.81,2.39,7.6,2.37s4.72-4.56,7.64-9,7.37-1.4,10,3a33.78,33.78,0,0,1-1.92,6.53c-1.75,3.75-10.2,8.85-15.28,10.55C323.08,411.31,314.77,407.52,317.66,402.93Z"
          style={{
            fill: "rgb(55, 71, 79)",
            transformOrigin: "333.815px 397.408px",
          }}
          id="elad4u23v2jyj"
          className="animable"
        />
        <g id="elryu22yjcfyo">
          <path
            d="M342.23,375.33a.66.66,0,1,0,1.22-.49.66.66,0,1,0-1.22.49Z"
            style={{
              opacity: 0.15,
              transformOrigin: "342.84px 375.085px",
            }}
            className="animable"
            id="elcctvqzf6wlk"
          />
        </g>
        <g id="elbtfqufh4nq">
          <path
            d="M340.09,379.55a.65.65,0,0,0,.85.37.66.66,0,1,0-.85-.37Z"
            style={{
              opacity: 0.15,
              transformOrigin: "340.702px 379.306px",
            }}
            className="animable"
            id="eldygplrcrhvh"
          />
        </g>
        <g id="elf0lq7jes4s4">
          <path
            d="M337.94,383.78a.66.66,0,1,0,.37-.85A.66.66,0,0,0,337.94,383.78Z"
            style={{
              opacity: 0.15,
              transformOrigin: "338.556px 383.543px",
            }}
            className="animable"
            id="elnfbv16h7ml"
          />
        </g>
        <g id="eleiv9k7wzcpj">
          <path
            d="M335.8,388a.66.66,0,1,0,.37-.85A.66.66,0,0,0,335.8,388Z"
            style={{
              opacity: 0.15,
              transformOrigin: "336.416px 387.763px",
            }}
            className="animable"
            id="el2siaa6626zg"
          />
        </g>
        <g id="els581m11w2fg">
          <path
            d="M333.66,392.24a.66.66,0,0,0,.85.37.66.66,0,1,0-.85-.37Z"
            style={{
              opacity: 0.15,
              transformOrigin: "334.272px 391.994px",
            }}
            className="animable"
            id="elesf4mj8ojlc"
          />
        </g>
        <path
          d="M342.93,375.33a.24.24,0,0,0,.14-.12.26.26,0,0,0-.1-.36c-.16-.09-4-2.2-8-.88h0a.27.27,0,0,0,.18.5c3.71-1.25,7.49.82,7.53.84A.25.25,0,0,0,342.93,375.33Z"
          style={{
            fill: "rgb(38, 50, 56)",
            transformOrigin: "338.97px 374.446px",
          }}
          id="elw992w5m0ln"
          className="animable"
        />
        <path
          d="M340.78,379.55a.24.24,0,0,0,.14-.12.25.25,0,0,0-.1-.36c-.16-.09-4-2.21-8-.88h0a.27.27,0,0,0-.16.33.27.27,0,0,0,.34.17c3.71-1.25,7.5.82,7.53.84A.28.28,0,0,0,340.78,379.55Z"
          style={{
            fill: "rgb(38, 50, 56)",
            transformOrigin: "336.804px 378.662px",
          }}
          id="el73yqry2sxgc"
          className="animable"
        />
        <path
          d="M338.65,383.79a.27.27,0,0,0,.14-.12.27.27,0,0,0-.11-.36c-.16-.09-4-2.21-8-.88h0a.26.26,0,0,0,.17.5c3.71-1.25,7.5.82,7.54.84A.28.28,0,0,0,338.65,383.79Z"
          style={{
            fill: "rgb(38, 50, 56)",
            transformOrigin: "334.66px 382.903px",
          }}
          id="elfhzkde4373"
          className="animable"
        />
        <path
          d="M336.5,388a.29.29,0,0,0,.15-.12.27.27,0,0,0-.11-.36c-.16-.09-4-2.21-8-.88h0a.27.27,0,0,0-.16.33.28.28,0,0,0,.34.17c3.71-1.25,7.5.82,7.54.84A.26.26,0,0,0,336.5,388Z"
          style={{
            fill: "rgb(38, 50, 56)",
            transformOrigin: "332.524px 387.112px",
          }}
          id="elwofzzemju9c"
          className="animable"
        />
        <path
          d="M334.36,392.25a.28.28,0,0,0,.14-.12.26.26,0,0,0-.1-.36c-.16-.09-4-2.21-8-.89h0a.26.26,0,0,0-.16.33.28.28,0,0,0,.34.17c3.71-1.25,7.5.82,7.53.84A.28.28,0,0,0,334.36,392.25Z"
          style={{
            fill: "rgb(38, 50, 56)",
            transformOrigin: "330.381px 391.358px",
          }}
          id="elpb0d3a9ohg"
          className="animable"
        />
        <path
          d="M298.91,211.8s-5.38-2.91-13.33-10.2C274,191,271.82,180.38,271.82,180.38l5-1.48L329.87,168c3.78,16.27,4.75,25,5.22,33.75,1.31,24.72,0,76,0,76,1,3.27,4,6.13,7.54,23.71,4,20.19,12.32,65.26,12.32,65.26s-3.39,10.3-23.09,7.73c0,0-27.35-82.53-28.86-100.15C301.34,255.21,298.91,211.8,298.91,211.8Z"
          style={{
            fill: "rgb(55, 71, 79)",
            transformOrigin: "313.385px 271.431px",
          }}
          id="elkyrhmcgtq4"
          className="animable"
        />
        <path
          d="M307.61,226.33s.71,42.57,1.1,49.84,23.13,75.44,23.13,75.44-19.73-64.94-20.68-75.94S307.61,226.33,307.61,226.33Z"
          style={{
            fill: "rgb(38, 50, 56)",
            transformOrigin: "319.725px 288.97px",
          }}
          id="elp15mk8g0i0s"
          className="animable"
        />
        <path
          d="M301.43,253.16s-2.72-35.55-2.51-41.36c0,0-10.81-1.75-14.61-4.62,0,0,3.2,4.45,11.27,7.32Z"
          style={{
            fill: "rgb(38, 50, 56)",
            transformOrigin: "292.87px 230.17px",
          }}
          id="elz4xfctcy68"
          className="animable"
        />
        <path
          d="M276.53,95.09c-8.38,1-14.54,2.11-18.79,13.61-2.93,7.93-24.45,67.31-24.45,67.31s16.15,2.07,20.53,2.27,6.06-.61,8.59-7.48,10.7-41,10.7-41Z"
          style={{
            fill: "rgb(38, 50, 56)",
            transformOrigin: "254.91px 136.698px",
          }}
          id="elkoevarlwmur"
          className="animable"
        />
        <path
          d="M270.45,120.58c1.39-11.14,8.91-25.94,14-26.34l22.88-1.85c4.93,1.19,13.87,2.62,19,4.33,6.8,1.56,9.16,17.53,6.41,44.88l-3,32.63c-9.07,9.87-41.4,11-61.21-3.5C268.17,168.46,268.68,134.66,270.45,120.58Z"
          style={{
            fill: "rgb(250, 250, 250)",
            transformOrigin: "301.142px 137.015px",
          }}
          id="elzdptqq5k2jp"
          className="animable"
        />
        <path
          d="M294.79,107.1s-7.27,28.69-5.53,60.39c0,0-2.94-14.34-.59-33.82S294.79,107.1,294.79,107.1Z"
          style={{
            fill: "rgb(224, 224, 224)",
            transformOrigin: "291.275px 137.295px",
          }}
          id="elqqpfds8ub39"
          className="animable"
        />
        <path
          d="M286.68,154.29c-3.66-14.64-.54-42.86,2.05-60.44a88.62,88.62,0,0,0-12.2,1.24c-3.87.82-10.28,9.4-8.91,32.44,1.65,27.6.92,67.43.92,67.43s9.95-1.21,18.14-15.77c0,0,8.92,13.4,24.76,19.83,15.36,6.24,25.68,4.64,25.68,4.64s.11-12.8-2.16-22.76c-5.63-24.69-2.27-27.57-1.06-40.34,1.64-17.51,6.47-28.75,1.21-42.2-1.18-3-20.14-5.1-20.14-5.1C302,112.2,292.07,131.74,286.68,154.29Z"
          style={{
            fill: "rgb(69, 90, 100)",
            transformOrigin: "302.465px 148.552px",
          }}
          id="elahz0wllcjxt"
          className="animable"
        />
        <path
          d="M286.68,154.29c-1.62,5-3.05,14.77-3.05,14.77s.38,6.28,3.05,10.13c0,0-2.82-1.6-4.37-9.9A71.72,71.72,0,0,1,286.68,154.29Z"
          style={{
            fill: "rgb(55, 71, 79)",
            transformOrigin: "284.495px 166.74px",
          }}
          id="elcz5yefh1u8u"
          className="animable"
        />
        <g id="elnld42tf6vb">
          <circle
            cx={288.28}
            cy={51.45}
            r={17.34}
            style={{
              fill: "rgb(38, 50, 56)",
              transformOrigin: "288.28px 51.45px",
              transform: "rotate(-5.65deg)",
            }}
            className="animable"
            id="eln6vfbwyzpx"
          />
        </g>
        <path
          d="M321.53,45.3a6.88,6.88,0,0,0-5.07-3.21l-7,1-3.67,15.56V81.25h4.8c2.68,0,4.23-2.7,5.11-6.17C315.66,75.08,325.08,51.45,321.53,45.3Z"
          style={{
            fill: "rgb(38, 50, 56)",
            transformOrigin: "314.06px 61.67px",
          }}
          id="elo7mac75vyaq"
          className="animable"
        />
        <path
          d="M309.1,63.56c1.07.64,2-1.54,3.13-3.09,1.53-2.11,7.54-3.78,9.7.77s-1.21,9.74-4.61,11.23A4.24,4.24,0,0,1,312,71.41l-.57,23s1,3.42-10.55,3a45.24,45.24,0,0,0-3,5.6L296.61,97s-4.4-2.36-5.43-3l0-7.69s-2.91.2-5.14.21c-3.86,0-8.39-.48-10.5-6.65-2.32-6.75-3.28-18.68-1.14-31.22,2.73-16.07,21.81-15.92,32-9.53S309.1,63.56,309.1,63.56Z"
          style={{
            fill: "rgb(255, 168, 167)",
            transformOrigin: "297.909px 69.0465px",
          }}
          id="el4wkdq22m3ci"
          className="animable"
        />
        <path
          d="M317.32,42.07a9.74,9.74,0,0,0-2-5.54c-2.37-2.88-6.33-3.77-9.85-4.2-5.05-.63-10.14-.32-15.16-1.34-1.25-.25-2.48-.57-3.7-.9-1-.28-2-.34-3-.54A65.32,65.32,0,0,1,275.8,27a2.77,2.77,0,0,0-1.62-.2,2.44,2.44,0,0,0-1.41,2.1,9.24,9.24,0,0,0,1.14,6.24,5.75,5.75,0,0,0-1.78-.86,1.84,1.84,0,0,0-1.8.54,2.45,2.45,0,0,0-.3,1.83q0,.41.12.81c1.69,8.77,8.38,11.58,16.34,11.7a23.36,23.36,0,0,0,11.77-3.46,11.31,11.31,0,0,0,8.09,7.91c-.19,2-2.18,14.35,2.56,12.7,2.39-.83,2.16-5,3.88-6.6S317.32,42.07,317.32,42.07Z"
          style={{
            fill: "rgb(38, 50, 56)",
            transformOrigin: "293.644px 46.6092px",
          }}
          id="elkwllptxbhz"
          className="animable"
        />
        <path
          d="M316.06,44.57l6.5-3.49a3.59,3.59,0,0,0-4.92-1.63A3.89,3.89,0,0,0,316.06,44.57Z"
          style={{
            fill: "rgb(38, 50, 56)",
            transformOrigin: "319.107px 41.8017px",
          }}
          id="elkfhfwq6cx4d"
          className="animable"
        />
        <path
          d="M291.2,86.25s6.88-.36,11-3,5.86-8.52,6.41-9.85c0,0-.74,7.88-4.47,11.38-3.38,3.16-12.92,4-12.92,4Z"
          style={{
            fill: "rgb(242, 143, 143)",
            transformOrigin: "299.905px 81.09px",
          }}
          id="elnxmv0hvwv5"
          className="animable"
        />
        <path
          d="M311.55,89l-.05,2a7.73,7.73,0,0,1-4.63,3.62c-5.83,2-7,1.72-7.17,2.35s-1.83,6-1.83,6l2.71-4.14a34.88,34.88,0,0,1,2.3,5.12c.24,1.25,5.8.31,8.94-2.69,4.33-4.14,4.42-8,4.42-8a68.26,68.26,0,0,0-3-7,2.43,2.43,0,0,0-1.6-1.07Z"
          style={{
            fill: "rgb(240, 240, 240)",
            transformOrigin: "307.055px 94.8391px",
          }}
          id="el1h655rgdlcih"
          className="animable"
        />
        <path
          d="M297.87,103.08s-.1-6.14-.68-6.9-2.92-1.31-4.22-2.48a4.23,4.23,0,0,1-1.78-3.35V87.17s-.59-.07-1.51,1.91c-.78,1.68-1.56,3.34-1.85,4.18s-.6,5,1.88,7.67c2.91,3.1,3.35,1.89,3.88,1.15S296.33,98,296.33,98Z"
          style={{
            fill: "rgb(240, 240, 240)",
            transformOrigin: "292.754px 95.1248px",
          }}
          id="elvamz4yg4u8n"
          className="animable"
        />
        <path
          d="M291.61,62.65a2,2,0,0,0,2,1.89,2,2,0,1,0-2-1.89Z"
          style={{
            fill: "rgb(38, 50, 56)",
            transformOrigin: "293.607px 62.54px",
          }}
          id="el4ikl0yblw2s"
          className="animable"
        />
        <path
          d="M293.26,54.54l4.25,2.06a2.49,2.49,0,0,0-1.14-3.24A2.31,2.31,0,0,0,293.26,54.54Z"
          style={{
            fill: "rgb(38, 50, 56)",
            transformOrigin: "295.495px 54.8694px",
          }}
          id="elv4dlbd4zkv"
          className="animable"
        />
        <path
          d="M293.71,73.44l-6.54,1.76a3.34,3.34,0,0,0,4.09,2.51A3.56,3.56,0,0,0,293.71,73.44Z"
          style={{
            fill: "rgb(177, 102, 104)",
            transformOrigin: "290.492px 75.6274px",
          }}
          id="elnw3uwqf30ja"
          className="animable"
        />
        <path
          d="M293.5,75.73a2.21,2.21,0,0,0-3.78,1.57,2.12,2.12,0,0,0,0,.44,3.31,3.31,0,0,0,1.5,0A3.44,3.44,0,0,0,293.5,75.73Z"
          style={{
            fill: "rgb(242, 143, 143)",
            transformOrigin: "291.604px 76.4507px",
          }}
          id="elsh8a5mrgi2c"
          className="animable"
        />
        <path
          d="M275.45,56.8l3.6-3.1a2.28,2.28,0,0,0-3.29-.33A2.5,2.5,0,0,0,275.45,56.8Z"
          style={{
            fill: "rgb(38, 50, 56)",
            transformOrigin: "276.98px 54.8086px",
          }}
          id="elbleodi1c529"
          className="animable"
        />
        <path
          d="M277,61.94a1.93,1.93,0,1,0,1.81-2.12A2,2,0,0,0,277,61.94Z"
          style={{
            fill: "rgb(38, 50, 56)",
            transformOrigin: "278.923px 61.7468px",
          }}
          id="elhvjkv8creuf"
          className="animable"
        />
        <polygon
          points="285.69 60.21 286.06 71.84 279.84 70.3 285.69 60.21"
          style={{
            fill: "rgb(242, 143, 143)",
            transformOrigin: "282.95px 66.025px",
          }}
          id="elxcq02vrgvij"
          className="animable"
        />
        <path
          d="M295.88,99.8a10.57,10.57,0,0,0-6.1-5c-1.57-.45-2.69.36-2.41,3.46.2,2.24-1.33,4.85-1.43,5.85s.9,2.18,3,2.31A9,9,0,0,0,295,104.3,14.81,14.81,0,0,0,295.88,99.8Z"
          style={{
            fill: "#213E60",
            transformOrigin: "290.907px 100.554px",
          }}
          id="elo9cc1e5fg59"
          className="animable"
        />
        <g id="elnj8of0470s">
          <path
            d="M295.88,99.8a10.57,10.57,0,0,0-6.1-5c-1.57-.45-2.69.36-2.41,3.46.2,2.24-1.33,4.85-1.43,5.85s.9,2.18,3,2.31A9,9,0,0,0,295,104.3,14.81,14.81,0,0,0,295.88,99.8Z"
            style={{
              opacity: 0.1,
              transformOrigin: "290.907px 100.554px",
            }}
            className="animable"
            id="elskridni9zzj"
          />
        </g>
        <g id="elahoewweouf">
          <path
            d="M295.07,101.08s-3.56-4.21-4.41-3.1C289.36,99.7,295.07,101.08,295.07,101.08Z"
            style={{
              opacity: 0.1,
              transformOrigin: "292.769px 99.4368px",
            }}
            className="animable"
            id="elwel8y1js3rm"
          />
        </g>
        <g id="elsx08akwlqlg">
          <path
            d="M295.25,102s-5,.14-4.65,1.36C291.07,105.25,295.25,102,295.25,102Z"
            style={{
              opacity: 0.1,
              transformOrigin: "292.916px 102.975px",
            }}
            className="animable"
            id="elvtlxbx10hd"
          />
        </g>
        <path
          d="M297.78,99.26c-1.2-.11-2.47-.14-3.06,1.6s-.48,3.26.33,3.72a7.45,7.45,0,0,0,3.63.69,1.81,1.81,0,0,0,1.83-1.53c.27-.93.85-2.92-.5-3.77A4.57,4.57,0,0,0,297.78,99.26Z"
          style={{
            fill: "#213E60",
            transformOrigin: "297.607px 102.251px",
          }}
          id="el26gz7lgs0yc"
          className="animable"
        />
        <path
          d="M300.36,100.4c1.34-1.29,4.39-3.87,8.09-3.73,1.79.07,2.69,1.3,1.34,4.45-1,2.27-.24,5.51-.48,6.59s-1.69,2-3.9,1.41a10.48,10.48,0,0,1-5.8-4.43A8.32,8.32,0,0,1,300.36,100.4Z"
          style={{
            fill: "#213E60",
            transformOrigin: "305.008px 102.985px",
          }}
          id="el568y0wiruop"
          className="animable"
        />
        <g id="ele6zzeknjez">
          <path
            d="M300.36,100.4c1.34-1.29,4.39-3.87,8.09-3.73,1.79.07,2.69,1.3,1.34,4.45-1,2.27-.24,5.51-.48,6.59s-1.69,2-3.9,1.41a10.48,10.48,0,0,1-5.8-4.43A8.32,8.32,0,0,1,300.36,100.4Z"
            style={{
              opacity: 0.1,
              transformOrigin: "305.008px 102.985px",
            }}
            className="animable"
            id="elbenpxs19orm"
          />
        </g>
        <g id="elretjysi8cs">
          <path
            d="M299.73,102.2l0-.16c.94-.64,4.33-2.88,4.8-1.76C305.31,102,300.76,102.18,299.73,102.2Z"
            style={{
              opacity: 0.1,
              transformOrigin: "302.175px 101.086px",
            }}
            className="animable"
            id="el5bswoje1vtg"
          />
        </g>
        <g id="elryzufh84ex">
          <path
            d="M303.54,105.5c-.78,1.43-3.16-1.24-3.93-2.16v-.22C300.59,103.41,304,104.56,303.54,105.5Z"
            style={{
              opacity: 0.1,
              transformOrigin: "301.596px 104.516px",
            }}
            className="animable"
            id="elgsxuv0ehbe4"
          />
        </g>
        <path
          d="M309,186.14c-1.46.72-6.36,2.88-9,2.74-4.37-.23-7.17.44-11.21.53-3.17.06-4.88-.86-5.2-.14-.4.92-.37,3.1,2.1,4.42a25.76,25.76,0,0,0,5.73,1.72,33.57,33.57,0,0,1-10.36,2.71c-8.19.8-11.12,3.4-3.79,10.91,4.6,4.7,11.17,5.56,24.94-1.15a113.24,113.24,0,0,0,12.26-7.82Z"
          style={{
            fill: "rgb(255, 168, 167)",
            transformOrigin: "293.774px 199.437px",
          }}
          id="ellr08gt1fsb"
          className="animable"
        />
        <polygon
          points="313.62 182.88 307.15 186.06 313.62 201.71 322.8 196.97 313.62 182.88"
          style={{
            fill: "rgb(250, 250, 250)",
            transformOrigin: "314.975px 192.295px",
          }}
          id="elg04z6ygbtp7"
          className="animable"
        />
        <path
          d="M330.81,96.08c10.11,1.14,12.06,6.35,18.46,24.89s12.14,36.65,13.91,42.83,1.76,9.06-5.52,14.35-38.8,22-38.8,22l-7.55-16.83,29.47-20.54-16-35.72S319.19,101.08,330.81,96.08Z"
          style={{
            fill: "rgb(55, 71, 79)",
            transformOrigin: "337.732px 148.115px",
          }}
          id="elkbgwi7pd4lj"
          className="animable"
        />
      </g>
      <g
        id="freepik--Bride--inject-63"
        className="animable"
        style={{
          transformOrigin: "194.413px 235.232px",
        }}
      >
        <path
          d="M222.48,52.28C223,46.61,218,40,209.68,41.14c-10.46,1.37-17.92,13.32-17.1,19.59s5.61,10.15,11.9,9S222.48,52.28,222.48,52.28Z"
          style={{
            fill: "rgb(55, 71, 79)",
            transformOrigin: "207.518px 55.4709px",
          }}
          id="el12e1w9bcmoag"
          className="animable"
        />
        <path
          d="M232.28,45.9a2.65,2.65,0,0,0-2,2.07,1.81,1.81,0,1,0-3.52.59,1.72,1.72,0,0,0-2.83-1A2,2,0,0,0,222.54,45a2.78,2.78,0,0,0-2.85,1,4.47,4.47,0,0,0-.91,3,1.75,1.75,0,0,0-3.37.39,2.05,2.05,0,1,0-3.9,1.29,2.22,2.22,0,0,0-2.3.5,2.46,2.46,0,0,0-.51,2.3c.06.58.13,1.95.93,2.12a5.34,5.34,0,0,0-3.76.19,2.32,2.32,0,0,0-1.09,1.28,1.3,1.3,0,0,0,.57,1.48,5.89,5.89,0,0,0-2.59.89,2.48,2.48,0,0,0-1.11,2.36,1.61,1.61,0,0,0,2,1.26,3.49,3.49,0,1,0,6,3.22,2.81,2.81,0,0,0,3.23,1.81,6.33,6.33,0,0,0,3.38-2.15L238,56.44a2.14,2.14,0,0,0,.16-4.28,2.57,2.57,0,0,0-2.73-2.9,4.72,4.72,0,0,0-.91-2.35A2.59,2.59,0,0,0,232.28,45.9Z"
          style={{
            fill: "#213E60",
            transformOrigin: "220.927px 56.879px",
          }}
          id="eltfjo0v9ax2"
          className="animable"
        />
        <path
          d="M209.34,57.66a2.19,2.19,0,1,1,3.58-2.32,1.72,1.72,0,0,1,2.57-.41,6.48,6.48,0,0,1-.79-2.19,2.13,2.13,0,0,1,.87-2,1.31,1.31,0,0,1,1.91.63c.47-2.1,3.78-2.91,5.25-1.4a2.76,2.76,0,0,1,4.53-.11,1.71,1.71,0,0,1,3-.06,2.36,2.36,0,0,1,4.2.85,1.46,1.46,0,0,1,1.69.49,1.79,1.79,0,0,1,.17,1.8,2.32,2.32,0,0,1-1.41,1.19c.5-.16.72,2,.69,2.23a1.79,1.79,0,0,1-1.68,1.62A5.93,5.93,0,0,1,223.75,61a9.61,9.61,0,0,1-4.47,5,5.32,5.32,0,0,1-6.23-1.16c.75.94-3.15,1.71-3.71,1.51-1.29-.47-2.27-2.2-3.07-3.27C204.46,60.64,205.72,56.28,209.34,57.66Z"
          style={{
            fill: "#213E60",
            transformOrigin: "220.969px 57.6347px",
          }}
          id="elybpwba0e7jq"
          className="animable"
        />
        <g id="elp2ahmfoapa">
          <path
            d="M209.34,57.66a2.19,2.19,0,1,1,3.58-2.32,1.72,1.72,0,0,1,2.57-.41,6.48,6.48,0,0,1-.79-2.19,2.13,2.13,0,0,1,.87-2,1.31,1.31,0,0,1,1.91.63c.47-2.1,3.78-2.91,5.25-1.4a2.76,2.76,0,0,1,4.53-.11,1.71,1.71,0,0,1,3-.06,2.36,2.36,0,0,1,4.2.85,1.46,1.46,0,0,1,1.69.49,1.79,1.79,0,0,1,.17,1.8,2.32,2.32,0,0,1-1.41,1.19c.5-.16.72,2,.69,2.23a1.79,1.79,0,0,1-1.68,1.62A5.93,5.93,0,0,1,223.75,61a9.61,9.61,0,0,1-4.47,5,5.32,5.32,0,0,1-6.23-1.16c.75.94-3.15,1.71-3.71,1.51-1.29-.47-2.27-2.2-3.07-3.27C204.46,60.64,205.72,56.28,209.34,57.66Z"
            style={{
              fill: "rgb(255, 255, 255)",
              opacity: 0.7,
              transformOrigin: "220.969px 57.6347px",
            }}
            className="animable"
            id="elagiqznpzmev"
          />
        </g>
        <path
          d="M257.31,63.59c-2.2-9.79-15.57-9.73-20.17-5L251.94,84S260.35,77.1,257.31,63.59Z"
          style={{
            fill: "rgb(38, 50, 56)",
            transformOrigin: "247.556px 69.742px",
          }}
          id="ele92s09a44bn"
          className="animable"
        />
        <path
          d="M234.05,50.28a22,22,0,0,0-5.54,1.92,48.71,48.71,0,0,1-5.87,2.71c-1.79.62-3.68.9-5.48,1.52a27.27,27.27,0,0,0-9.95,5.81c-8.8,8.34-7.12,22.18-.49,31.34a37.42,37.42,0,0,0,2.6,3.17c4.26,4.7,7.72,7.86,8.54,9.69L217.57,90a11.65,11.65,0,0,0,2.79-.62c4.94-1.85,21.15-9.22,24.81-16,3.08-5.68,2.64-8.77,2.64-8.79C249.11,53.5,241.76,48.91,234.05,50.28Z"
          style={{
            fill: "rgb(55, 71, 79)",
            transformOrigin: "224.565px 78.2423px",
          }}
          id="elu70nxdnm6g"
          className="animable"
        />
        <path
          d="M242.3,69.21c-2.72-.09-4.41-2-8.08-4.88S223.86,63,222.93,68.48s0,9.9-1.72,13C226.84,81.27,242.3,69.21,242.3,69.21Z"
          style={{
            fill: "rgb(38, 50, 56)",
            transformOrigin: "231.755px 72.194px",
          }}
          id="ely24yj57ju1"
          className="animable"
        />
        <path
          d="M244.92,115.2c7.35.44,10.29,1.64,15.94,10.73,5.18,8.33,7.27,12.45,7.27,12.45l.64,33.26-23.19-33.21Z"
          style={{
            fill: "rgb(255, 168, 167)",
            transformOrigin: "256.845px 143.42px",
          }}
          id="ely17p3ia78wb"
          className="animable"
        />
        <path
          d="M208.07,178s-17.47,13.16-27.93,33.71-65.59,148.1-71.24,166.46c0,0,1.48,20,26.47,26.18a26,26,0,0,0,13.18,11.46c16,6,27,.34,27,.34s2,8.55,21.39,12.53c13.14,2.69,20.83-2.5,20.83-2.5s11.37,4.83,21.44.92c11.8-4.58,15.18-12,15.18-12s20,3.48,25.48-8.79C281.15,391.75,260,210.6,250.35,180Z"
          style={{
            fill: "rgb(240, 240, 240)",
            transformOrigin: "194.413px 303.727px",
          }}
          id="el9ueyii8w64n"
          className="animable"
        />
        <path
          d="M169.35,418a61.72,61.72,0,0,0,6.25-1.89s32-167,38.27-201.51C213.87,214.64,175.79,383.72,169.35,418Z"
          style={{
            fill: "rgb(230, 230, 230)",
            transformOrigin: "191.61px 316.3px",
          }}
          id="ely0mpxkqy2th"
          className="animable"
        />
        <path
          d="M222.68,427.68c3.46-39.91,9-211.25,9-211.25-1.76,30.21-13.88,209.74-13.88,209.75h0A32.86,32.86,0,0,0,222.68,427.68Z"
          style={{
            fill: "rgb(230, 230, 230)",
            transformOrigin: "224.74px 322.055px",
          }}
          id="el1fksc99zfof"
          className="animable"
        />
        <path
          d="M260.1,415.6c-.84-28.66-6-138.43-7.19-154.58a564.92,564.92,0,0,0-8.21-59.72c6,32.43,9.06,183.09,9.64,214.05l.1-.2A39.17,39.17,0,0,0,260.1,415.6Z"
          style={{
            fill: "rgb(230, 230, 230)",
            transformOrigin: "252.4px 308.45px",
          }}
          id="elsovn15h0sy"
          className="animable"
        />
        <path
          d="M135.36,404.35c6.76-23,46.34-149.85,70.82-207.5-24.91,49.51-53.88,134.56-76.66,205.77C131.33,403.25,133.27,403.84,135.36,404.35Z"
          style={{
            fill: "rgb(230, 230, 230)",
            transformOrigin: "167.85px 300.6px",
          }}
          id="elr048aif2hb"
          className="animable"
        />
        <path
          d="M207.81,172.88v5.27s3.87,6.76,22.82,6.76c20.21,0,19.84-5.45,19.84-5.45l.13-5.67Z"
          style={{
            fill: "#213E60",
            transformOrigin: "229.205px 178.895px",
          }}
          id="elbyl0cr14189"
          className="animable"
        />
        <path
          d="M254.18,155.79c-.4,4.49-2.25,12.77-3.58,18s-33.88,7.86-42.79-.91L201,152.56s-.91-2.18-.89-2.2c.51-.88,13.49-14.87,3.35-34l15.57-1.3,17.63-.52c4.4.25,8.3.65,8.3.65,2.82,2.64,6.64,8.45,10.44,16C257.65,135.78,262.05,142.18,254.18,155.79Z"
          style={{
            fill: "rgb(255, 168, 167)",
            transformOrigin: "229.391px 146.572px",
          }}
          id="elbzzplsdfgyl"
          className="animable"
        />
        <path
          d="M241.29,140s-2.4-5-10.17-7.73c-10.16-3.57-21,2.42-25.46,12.36-3,4.16-5.21,5.06-5.59,5.72,0,0,.89,2.2.89,2.2l6.85,20.32c8.91,8.77,41.47,6.11,42.79.91s3.49-13.55,3.89-18c8.79-12.73,4.62-19.12,2-23.5a38,38,0,0,0-2.27-3.22C248.1,127.06,241.71,134,241.29,140Z"
          style={{
            fill: "rgb(240, 240, 240)",
            transformOrigin: "229.938px 153.647px",
          }}
          id="elb3sb1gde9aw"
          className="animable"
        />
        <path
          d="M247.81,64.54c2.15,2.11,4.7,6.63,5.12,22.81.36,13.72-3.92,17.33-6.1,18.41s-6,.8-10.21.31v8.48s1.73,3.79-5.74,4.59c-11.33,1.22-12.64-3.44-12.64-3.44l-.88-19.85s-2.13,2.61-6.58-.71c-2.18-1.63-4-6.93-1.47-9.79s6.49-2.58,8.58,1.21c0,0,.2-16.77,9.9-19.73C237.31,63.92,242.08,75.17,247.81,64.54Z"
          style={{
            fill: "rgb(255, 168, 167)",
            transformOrigin: "230.516px 91.9418px",
          }}
          id="eldadubmb1ww4"
          className="animable"
        />
        <path
          d="M217.9,86.54l.23,4.6h0a3.43,3.43,0,0,0,3.26-3.6l-.18-6.08c1.84-2,1.54-9.64,1.72-13,0,0-5.08,6.66-5.5,9.07S217.9,86.54,217.9,86.54Z"
          style={{
            fill: "rgb(55, 71, 79)",
            transformOrigin: "220.124px 79.8px",
          }}
          id="elf9fxfklyyih"
          className="animable"
        />
        <path
          d="M226,74.77c1.12-4.82,6.79-7.62,13.13-6.22l-9.47-4.69-6.38,3.35a7.19,7.19,0,0,0-.36,1.27c-.92,5.49,0,9.9-1.72,13h0A10.56,10.56,0,0,0,226,74.77Z"
          style={{
            fill: "rgb(38, 50, 56)",
            transformOrigin: "230.165px 72.67px",
          }}
          id="elvbbftev66lk"
          className="animable"
        />
        <path
          d="M236.23,83a1.72,1.72,0,1,1-2-1.53A1.77,1.77,0,0,1,236.23,83Z"
          style={{
            fill: "rgb(38, 50, 56)",
            transformOrigin: "234.518px 83.1694px",
          }}
          id="elg8e3rtxerc8"
          className="animable"
        />
        <path
          d="M233.12,82.19a1.77,1.77,0,0,1-1.69.3s.31.93,1.56.61C234,82.82,233.12,82.19,233.12,82.19Z"
          style={{
            fill: "rgb(38, 50, 56)",
            transformOrigin: "232.453px 82.6785px",
          }}
          id="elx8bv5rki5p"
          className="animable"
        />
        <path
          d="M249.1,80.35a1.81,1.81,0,0,0,1.76-.36s-.05,1.25-1.21,1.22S249.1,80.35,249.1,80.35Z"
          style={{
            fill: "rgb(38, 50, 56)",
            transformOrigin: "249.9px 80.6003px",
          }}
          id="elawd3w71obsm"
          className="animable"
        />
        <g id="elx43d6b6a9rg">
          <g
            style={{
              opacity: 0.5,
              mixBlendMode: "multiply",
              transformOrigin: "240.2px 96.7433px",
            }}
            className="animable"
            id="elsqg52k8q0i"
          >
            <path
              d="M237.69,95.14l5.07,1.08a2.55,2.55,0,0,1-3,2.08A2.71,2.71,0,0,1,237.69,95.14Z"
              style={{
                fill: "rgb(255, 168, 167)",
                transformOrigin: "240.2px 96.7433px",
              }}
              id="elr5zl8gco1w"
              className="animable"
            />
          </g>
        </g>
        <path
          d="M251,77.55,247,76a2,2,0,0,1,2.68-1.25A2.23,2.23,0,0,1,251,77.55Z"
          style={{
            fill: "rgb(38, 50, 56)",
            transformOrigin: "249.059px 76.0728px",
          }}
          id="el4b81xpgoxdq"
          className="animable"
        />
        <path
          d="M233.93,77.29l-3.52,2.37a2,2,0,0,1,.49-2.91A2.23,2.23,0,0,1,233.93,77.29Z"
          style={{
            fill: "rgb(38, 50, 56)",
            transformOrigin: "231.958px 78.0194px",
          }}
          id="eli7f64eeq9c"
          className="animable"
        />
        <path
          d="M250.17,81.58a1.74,1.74,0,0,1-1.44,2,1.76,1.76,0,0,1-2-1.52,1.72,1.72,0,1,1,3.41-.5Z"
          style={{
            fill: "rgb(38, 50, 56)",
            transformOrigin: "248.452px 81.8408px",
          }}
          id="elk4vhs78jmc"
          className="animable"
        />
        <g id="elo9v3a0vx45i">
          <g
            style={{
              opacity: 0.5,
              mixBlendMode: "multiply",
              transformOrigin: "245.58px 87.075px",
            }}
            className="animable"
            id="elsu4mpy25cbk"
          >
            <polygon
              points="242.3 81.92 243.59 92.23 248.86 90.01 242.3 81.92"
              style={{
                fill: "rgb(255, 168, 167)",
                transformOrigin: "245.58px 87.075px",
              }}
              id="eldxqf8z50bni"
              className="animable"
            />
          </g>
        </g>
        <g id="eldifzziw9v0i">
          <g
            style={{
              opacity: 0.5,
              mixBlendMode: "multiply",
              transformOrigin: "228.75px 104.26px",
            }}
            className="animable"
            id="elz5vccsmmp1b"
          >
            <path
              d="M236.62,106.07c-4.44-.37-14.15-2.62-15.74-6.13a9.36,9.36,0,0,0,3.41,4.42c2.82,2.18,12.33,4.22,12.33,4.22Z"
              style={{
                fill: "rgb(255, 168, 167)",
                transformOrigin: "228.75px 104.26px",
              }}
              id="el207557r29lw"
              className="animable"
            />
          </g>
        </g>
        <path
          d="M218.21,115.13c1,1.91,5.33,3.24,10.28,3.42,4.15.16,7.67-1,8.13-4v-2.77s-.69,3.25-6.68,3.25c-9.6,0-11.86-3-11.86-3Z"
          style={{
            fill: "#213E60",
            transformOrigin: "227.35px 115.172px",
          }}
          id="elltwfrk8kazf"
          className="animable"
        />
        <path
          d="M235.56,120.37a1.68,1.68,0,0,1-3.32.49c-.14-.91.3-3,1.22-3.18S235.42,119.45,235.56,120.37Z"
          style={{
            fill: "rgb(69, 90, 100)",
            transformOrigin: "233.891px 119.941px",
          }}
          id="el8u4xd3gm34t"
          className="animable"
        />
        <path
          d="M178.66,162.36c7.62-31,10.63-44.59,24.84-46,10.05,5.3,7,20.27,2.16,28.26L194.12,178.9c4.17,3.54,31.25,18.94,33.19,19.44,1.46.37,3.08.81,4.44.17,3.65-1.71,6.55-1,10.21-1.69,2.86-.55,4.23-1.71,4.65-1.13.54.76.94,2.72-1,4.39a23.43,23.43,0,0,1-4.83,2.66,30.91,30.91,0,0,0,9.86.43c7.53-.85,10.68.93,5.52,9.11-3.23,5.13-9,7.17-22.7,3.79-3.94-1-10.31-3.75-15.07-5.73-9.84-4.1-35.26-15.39-40.6-20.13-4.31-3.83-3.83-5.29-2.72-12.06S177.53,167,178.66,162.36Z"
          style={{
            fill: "rgb(255, 168, 167)",
            transformOrigin: "216.501px 167.045px",
          }}
          id="eli7kyif4to3"
          className="animable"
        />
      </g>
      <g
        id="freepik--Flowers--inject-63"
        className="animable"
        style={{
          transformOrigin: "266.23px 214.683px",
        }}
      >
        <path
          d="M247.22,199.65c1.09-5.33-2.13-7.64-9.46-8.64,0,0-.8,4,1,6.46C240.9,200.55,245.41,201.15,247.22,199.65Z"
          style={{
            fill: "#213E60",
            transformOrigin: "242.505px 195.724px",
          }}
          id="el84mwgjm0lsn"
          className="animable"
        />
        <g id="elf4zpzuasyv">
          <path
            d="M247.22,199.65c1.09-5.33-2.13-7.64-9.46-8.64,0,0-.8,4,1,6.46C240.9,200.55,245.41,201.15,247.22,199.65Z"
            style={{
              opacity: 0.3,
              transformOrigin: "242.505px 195.724px",
            }}
            className="animable"
            id="el68vvxyk5u0l"
          />
        </g>
        <g id="elazrlbpelzo6">
          <path
            d="M239.06,192.1c2,1.34,6.87,4.45,8.16,7.55l.2-1.19S246.61,195.69,239.06,192.1Z"
            style={{
              opacity: 0.2,
              transformOrigin: "243.24px 195.875px",
            }}
            className="animable"
            id="elqw19vxqe6q"
          />
        </g>
        <path
          d="M245.94,200.38c-4.34-3.29-7.81-1.38-11.88,4.82,0,0,3.26,2.43,6.25,1.91C244,206.46,246.52,202.66,245.94,200.38Z"
          style={{
            fill: "#213E60",
            transformOrigin: "240.042px 202.986px",
          }}
          id="el9eag63an69"
          className="animable"
        />
        <g id="elhcl72m4g70a">
          <path
            d="M245.94,200.38c-4.34-3.29-7.81-1.38-11.88,4.82,0,0,3.26,2.43,6.25,1.91C244,206.46,246.52,202.66,245.94,200.38Z"
            style={{
              opacity: 0.2,
              transformOrigin: "240.042px 202.986px",
            }}
            className="animable"
            id="elrvu4lpxgwqe"
          />
        </g>
        <g id="el8xaugksuvng">
          <path
            d="M235.61,204.49c2-1.19,7-4.29,10.33-4.11l-1-.7S242.1,199.22,235.61,204.49Z"
            style={{
              opacity: 0.2,
              transformOrigin: "240.775px 202.08px",
            }}
            className="animable"
            id="elzhz85t88sv"
          />
        </g>
        <path
          d="M285.24,194.18c-1.09-5.33,2.12-7.64,9.46-8.65,0,0,.8,4-.95,6.46C291.56,195.08,287.05,195.68,285.24,194.18Z"
          style={{
            fill: "#213E60",
            transformOrigin: "289.957px 190.248px",
          }}
          id="el69p9720jdpk"
          className="animable"
        />
        <g id="el89j3jh2fwqg">
          <path
            d="M285.24,194.18c-1.09-5.33,2.12-7.64,9.46-8.65,0,0,.8,4-.95,6.46C291.56,195.08,287.05,195.68,285.24,194.18Z"
            style={{
              opacity: 0.3,
              transformOrigin: "289.957px 190.248px",
            }}
            className="animable"
            id="el0j9jlsy6co9s"
          />
        </g>
        <g id="el8gz584dkqci">
          <path
            d="M293.4,186.62c-2,1.34-6.88,4.46-8.16,7.56L285,193S285.85,190.22,293.4,186.62Z"
            style={{
              opacity: 0.2,
              transformOrigin: "289.2px 190.4px",
            }}
            className="animable"
            id="elrbgkeejft1s"
          />
        </g>
        <path
          d="M286.52,194.9c4.34-3.28,7.81-1.37,11.88,4.82,0,0-3.26,2.43-6.25,1.91C288.43,201,285.94,197.18,286.52,194.9Z"
          style={{
            fill: "#213E60",
            transformOrigin: "292.418px 197.509px",
          }}
          id="elddjejs3w5c"
          className="animable"
        />
        <g id="elhj0y7p4mrnq">
          <path
            d="M286.52,194.9c4.34-3.28,7.81-1.37,11.88,4.82,0,0-3.26,2.43-6.25,1.91C288.43,201,285.94,197.18,286.52,194.9Z"
            style={{
              opacity: 0.2,
              transformOrigin: "292.418px 197.509px",
            }}
            className="animable"
            id="el4s6v9v1qwv2"
          />
        </g>
        <g id="elx1s0377iemf">
          <path
            d="M296.85,199c-2.05-1.19-7-4.29-10.33-4.11l1-.7S290.35,193.74,296.85,199Z"
            style={{
              opacity: 0.2,
              transformOrigin: "291.685px 196.59px",
            }}
            className="animable"
            id="eldw6bmfax5t9"
          />
        </g>
        <path
          d="M259.85,182.74a5.52,5.52,0,0,0-2.74,2.18c-.25.39-1.46,3.2-1.05,3.52-1.63-1.29-4.77-2.89-6.69-1.54-1.38,1-2.38,4.81-.46,5.81-1-.52-2.24-1-3.16-.4s-.84,2.25-.05,3.12a6.31,6.31,0,0,0,3.14,1.5c-.87-.45-1.92.51-2,1.49a5.28,5.28,0,0,0,1,2.72,3.39,3.39,0,0,1,.55,2.78,11.69,11.69,0,0,0-4-1,4,4,0,0,0-3.56,1.72,2.47,2.47,0,0,0,1,3.49,2.36,2.36,0,1,0,1.88,4,3.68,3.68,0,1,0,3.64,6.39,3.3,3.3,0,0,0,6.16,2.32c.42,1.35-.95,2.57-2.24,3.14s-2.83,1.1-3.33,2.42a2.87,2.87,0,0,0,1.89,3.44,5.5,5.5,0,0,0,4.22-.52,2.79,2.79,0,0,0,4.66,3c-.44.63-1.21,1.37-1.21,2.19a2.83,2.83,0,0,0,1.91,2.25,7.51,7.51,0,0,0,3.71.05,6.19,6.19,0,0,0-.88,4.37,3.3,3.3,0,0,0,3.26,2.64,2,2,0,0,0,1.12,3,3,3,0,0,0,3.2-1.4,5.47,5.47,0,0,0,.57-3.63c.85.56,2-.3,2.26-1.29a10.06,10.06,0,0,0-.12-3c0-.66.09-1.87.76-2.25s2.11.54,3.08.49c1.73-.07,3.43-1.85,2.79-3.47.3,1.9,3,2.64,4.56,1.52a4.83,4.83,0,0,0,1.42-5.21,14.22,14.22,0,0,0-3-4.88,4.68,4.68,0,1,0,2.76-8.87,8.82,8.82,0,0,0,3.58.5,3,3,0,0,0,2.63-2.16c.23-1.2-.95-2.54-2.11-2.16a7.81,7.81,0,0,0,2.23-5c0-1.87-1.49-3.8-3.35-3.75a4.2,4.2,0,0,0-2.54-7.93,11.44,11.44,0,0,0-1-6.7,7.31,7.31,0,0,0-5.32-4,5.43,5.43,0,0,0-5.64,3,4.88,4.88,0,0,0-3.13-4c-1.72-.48-3.88,1-3.6,2.74A5.9,5.9,0,0,0,259.85,182.74Z"
          style={{
            fill: "#213E60",
            transformOrigin: "265.445px 214.683px",
          }}
          id="elxcxhj2agmu"
          className="animable"
        />
        <g id="elhyv5u4xb4nm">
          <path
            d="M259.85,182.74a5.52,5.52,0,0,0-2.74,2.18c-.25.39-1.46,3.2-1.05,3.52-1.63-1.29-4.77-2.89-6.69-1.54-1.38,1-2.38,4.81-.46,5.81-1-.52-2.24-1-3.16-.4s-.84,2.25-.05,3.12a6.31,6.31,0,0,0,3.14,1.5c-.87-.45-1.92.51-2,1.49a5.28,5.28,0,0,0,1,2.72,3.39,3.39,0,0,1,.55,2.78,11.69,11.69,0,0,0-4-1,4,4,0,0,0-3.56,1.72,2.47,2.47,0,0,0,1,3.49,2.36,2.36,0,1,0,1.88,4,3.68,3.68,0,1,0,3.64,6.39,3.3,3.3,0,0,0,6.16,2.32c.42,1.35-.95,2.57-2.24,3.14s-2.83,1.1-3.33,2.42a2.87,2.87,0,0,0,1.89,3.44,5.5,5.5,0,0,0,4.22-.52,2.79,2.79,0,0,0,4.66,3c-.44.63-1.21,1.37-1.21,2.19a2.83,2.83,0,0,0,1.91,2.25,7.51,7.51,0,0,0,3.71.05,6.19,6.19,0,0,0-.88,4.37,3.3,3.3,0,0,0,3.26,2.64,2,2,0,0,0,1.12,3,3,3,0,0,0,3.2-1.4,5.47,5.47,0,0,0,.57-3.63c.85.56,2-.3,2.26-1.29a10.06,10.06,0,0,0-.12-3c0-.66.09-1.87.76-2.25s2.11.54,3.08.49c1.73-.07,3.43-1.85,2.79-3.47.3,1.9,3,2.64,4.56,1.52a4.83,4.83,0,0,0,1.42-5.21,14.22,14.22,0,0,0-3-4.88,4.68,4.68,0,1,0,2.76-8.87,8.82,8.82,0,0,0,3.58.5,3,3,0,0,0,2.63-2.16c.23-1.2-.95-2.54-2.11-2.16a7.81,7.81,0,0,0,2.23-5c0-1.87-1.49-3.8-3.35-3.75a4.2,4.2,0,0,0-2.54-7.93,11.44,11.44,0,0,0-1-6.7,7.31,7.31,0,0,0-5.32-4,5.43,5.43,0,0,0-5.64,3,4.88,4.88,0,0,0-3.13-4c-1.72-.48-3.88,1-3.6,2.74A5.9,5.9,0,0,0,259.85,182.74Z"
            style={{
              fill: "rgb(255, 255, 255)",
              opacity: 0.5,
              transformOrigin: "265.445px 214.683px",
            }}
            className="animable"
            id="el7ox19r5pi5v"
          />
        </g>
        <path
          d="M274.48,188.37c-1-.43-6.1,0-5.8,2.08-.47-3.18-4.78-3.91-6.95-2.27a4.77,4.77,0,0,0-5.64-3.41,4.65,4.65,0,0,0-2.93,5.93,5,5,0,0,0-4.75,8.62,4.53,4.53,0,0,0-.21,9,5.18,5.18,0,0,0,2.86,9.78,4.38,4.38,0,0,0-.89,5.86c1.37,1.71,4.58,1.55,5.48-.45a3.86,3.86,0,0,0,7,3.09c-1.79,2.4-.06,6.47,2.92,6.84s5.66-3.13,4.52-5.9a9.29,9.29,0,0,0,3.9,3.56,5.05,5.05,0,0,0,5.07-.44,3.52,3.52,0,0,0,.78-4.75,3.62,3.62,0,1,0,3.43-6,5.43,5.43,0,0,0,1.84-9.67,4,4,0,0,0-2.55-7.67,5.51,5.51,0,0,0,.68-7.28,4.82,4.82,0,0,0-7.07-.23A4.57,4.57,0,0,0,274.48,188.37Z"
          style={{
            fill: "#213E60",
            transformOrigin: "266.079px 209.062px",
          }}
          id="elt4yccxe7go"
          className="animable"
        />
        <g id="el9a2kwruuu7k">
          <path
            d="M274.48,188.37c-1-.43-6.1,0-5.8,2.08-.47-3.18-4.78-3.91-6.95-2.27a4.77,4.77,0,0,0-5.64-3.41,4.65,4.65,0,0,0-2.93,5.93,5,5,0,0,0-4.75,8.62,4.53,4.53,0,0,0-.21,9,5.18,5.18,0,0,0,2.86,9.78,4.38,4.38,0,0,0-.89,5.86c1.37,1.71,4.58,1.55,5.48-.45a3.86,3.86,0,0,0,7,3.09c-1.79,2.4-.06,6.47,2.92,6.84s5.66-3.13,4.52-5.9a9.29,9.29,0,0,0,3.9,3.56,5.05,5.05,0,0,0,5.07-.44,3.52,3.52,0,0,0,.78-4.75,3.62,3.62,0,1,0,3.43-6,5.43,5.43,0,0,0,1.84-9.67,4,4,0,0,0-2.55-7.67,5.51,5.51,0,0,0,.68-7.28,4.82,4.82,0,0,0-7.07-.23A4.57,4.57,0,0,0,274.48,188.37Z"
            style={{
              fill: "rgb(255, 255, 255)",
              opacity: 0.65,
              transformOrigin: "266.079px 209.062px",
            }}
            className="animable"
            id="elvxu83gyqwq"
          />
        </g>
        <path
          d="M252.89,206.34a10.49,10.49,0,0,0,1.87.2,9.24,9.24,0,0,0-2.64,2A2.77,2.77,0,0,0,254,213.3a9.29,9.29,0,0,0,3.14-.33,2.88,2.88,0,0,0,3.73,4.39c-.6,1.38-1.19,3.06-.36,4.32.94,1.42,3,1.35,4.7,1.12a3.53,3.53,0,0,0,.07,3.94c1,1.3,2.27,1.23,3.75,1.37a2.12,2.12,0,1,0,1,4.06,19.68,19.68,0,0,1-2,1.77,2.47,2.47,0,0,0-.89,2.36,2,2,0,0,0,2.77,1,3.93,3.93,0,0,0,1.91-2.62,2.56,2.56,0,0,0,2.87-1.51c.68-1.76-.69-3-2.18-3.5a3.79,3.79,0,0,0-1.79-7.36c-.19-.6-.38-1.2-.58-1.8a11.42,11.42,0,0,0,4.51,0,3.83,3.83,0,0,0,3-3.06c.15-1.51-1.4-3.07-2.83-2.55a3.07,3.07,0,0,0,3.48-2.12,2.6,2.6,0,0,0,3.66-1.57,3.53,3.53,0,0,0-1.84-3.87,5.65,5.65,0,0,0-4.49-.16c0-1.05-1.35-1.61-2.37-1.37s-1.91.92-2.94,1.16-2.4-.29-2.4-1.35a8.82,8.82,0,0,0,3.17-3.25,3.46,3.46,0,0,0-.7-4.18c-1.21-.94-3.43-.18-3.46,1.35a2.75,2.75,0,0,0-4.76-2.2,8.48,8.48,0,0,0,.51-3.91,3.19,3.19,0,0,0-2.52-2.72c-2.27-.27-2.18,2.07-2.07,3.57a3,3,0,0,0-2.34-1,2,2,0,0,0-1.83,1.6,1.46,1.46,0,0,0,1.61,1.6c-1.05.72-2.77.27-3.48,1.32a1.81,1.81,0,0,0,.51,2.26,5.27,5.27,0,0,0,2.32.93,7.62,7.62,0,0,0-2.91.86,2.3,2.3,0,0,0,.33,4.32A3,3,0,0,0,252.89,206.34Z"
          style={{
            fill: "#213E60",
            transformOrigin: "266.321px 214.108px",
          }}
          id="eli38my3j1yan"
          className="animable"
        />
        <g id="elrfrjn9es0a">
          <path
            d="M252.89,206.34a10.49,10.49,0,0,0,1.87.2,9.24,9.24,0,0,0-2.64,2A2.77,2.77,0,0,0,254,213.3a9.29,9.29,0,0,0,3.14-.33,2.88,2.88,0,0,0,3.73,4.39c-.6,1.38-1.19,3.06-.36,4.32.94,1.42,3,1.35,4.7,1.12a3.53,3.53,0,0,0,.07,3.94c1,1.3,2.27,1.23,3.75,1.37a2.12,2.12,0,1,0,1,4.06,19.68,19.68,0,0,1-2,1.77,2.47,2.47,0,0,0-.89,2.36,2,2,0,0,0,2.77,1,3.93,3.93,0,0,0,1.91-2.62,2.56,2.56,0,0,0,2.87-1.51c.68-1.76-.69-3-2.18-3.5a3.79,3.79,0,0,0-1.79-7.36c-.19-.6-.38-1.2-.58-1.8a11.42,11.42,0,0,0,4.51,0,3.83,3.83,0,0,0,3-3.06c.15-1.51-1.4-3.07-2.83-2.55a3.07,3.07,0,0,0,3.48-2.12,2.6,2.6,0,0,0,3.66-1.57,3.53,3.53,0,0,0-1.84-3.87,5.65,5.65,0,0,0-4.49-.16c0-1.05-1.35-1.61-2.37-1.37s-1.91.92-2.94,1.16-2.4-.29-2.4-1.35a8.82,8.82,0,0,0,3.17-3.25,3.46,3.46,0,0,0-.7-4.18c-1.21-.94-3.43-.18-3.46,1.35a2.75,2.75,0,0,0-4.76-2.2,8.48,8.48,0,0,0,.51-3.91,3.19,3.19,0,0,0-2.52-2.72c-2.27-.27-2.18,2.07-2.07,3.57a3,3,0,0,0-2.34-1,2,2,0,0,0-1.83,1.6,1.46,1.46,0,0,0,1.61,1.6c-1.05.72-2.77.27-3.48,1.32a1.81,1.81,0,0,0,.51,2.26,5.27,5.27,0,0,0,2.32.93,7.62,7.62,0,0,0-2.91.86,2.3,2.3,0,0,0,.33,4.32A3,3,0,0,0,252.89,206.34Z"
            style={{
              fill: "rgb(255, 255, 255)",
              opacity: 0.75,
              transformOrigin: "266.321px 214.108px",
            }}
            className="animable"
            id="elvscx6o9jaz8"
          />
        </g>
        <g
          id="freepik--flowers--inject-63"
          className="animable"
          style={{
            transformOrigin: "264.461px 209.054px",
          }}
        >
          <path
            d="M263.25,197.79s-.19-2.67-2.29-3c0,0-1.72-.28-2.67,2.39a5.52,5.52,0,0,0-5,.57,3.1,3.1,0,0,0,2.29,3.44s-1.62,1.24-.85,4.2c0,0,4.29,1.43,5.34-1.24,0,0,.38,2.39,4.58,2.39a4,4,0,0,0,0-4.78s3-.09,3.44-2.29C268.12,199.51,266.12,196.17,263.25,197.79Z"
            style={{
              fill: "rgb(250, 250, 250)",
              transformOrigin: "260.674px 200.661px",
            }}
            id="eliop4no81u"
            className="animable"
          />
          <path
            d="M260.61,198.22a2.41,2.41,0,0,0-2.53,2s0,1.56,2.14,1.79,2.46-1.34,2.46-1.34A2.47,2.47,0,0,0,260.61,198.22Z"
            style={{
              fill: "rgb(240, 153, 122)",
              transformOrigin: "260.38px 200.124px",
            }}
            id="eljpxrhu88iq"
            className="animable"
          />
          <path
            d="M278.92,194.21s-.94-1.9-2.48-2.12a4.23,4.23,0,0,0-1.53,2.73,3.94,3.94,0,0,0-3.38.83,3.61,3.61,0,0,0,2.15,2.48,4.76,4.76,0,0,0,.11,3.52s3,.22,4-2.25c0,0,1.1,1.64,4.13,1.06a3.09,3.09,0,0,0-1.1-3.6s1.87-1.07,1.65-2.87A4.66,4.66,0,0,0,278.92,194.21Z"
            style={{
              fill: "rgb(250, 250, 250)",
              transformOrigin: "277.009px 196.873px",
            }}
            id="elfop6inbdh8"
            className="animable"
          />
          <path
            d="M277.19,195.34a1.8,1.8,0,0,0-1.66,1.73s.17,1.14,1.78,1.06,1.68-1.26,1.68-1.26A1.84,1.84,0,0,0,277.19,195.34Z"
            style={{
              fill: "rgb(240, 153, 122)",
              transformOrigin: "277.26px 196.737px",
            }}
            id="eljj03vqt3s"
            className="animable"
          />
          <path
            d="M274.81,224.12s-.66-1.34-1.74-1.49a3,3,0,0,0-1.07,1.92,2.73,2.73,0,0,0-2.37.58,2.52,2.52,0,0,0,1.5,1.74,3.36,3.36,0,0,0,.08,2.47,2.93,2.93,0,0,0,2.82-1.58s.77,1.15,2.9.75a2.17,2.17,0,0,0-.78-2.53,2.28,2.28,0,0,0,1.16-2A3.26,3.26,0,0,0,274.81,224.12Z"
            style={{
              fill: "rgb(250, 250, 250)",
              transformOrigin: "273.47px 225.989px",
            }}
            id="elcdiqksyix4"
            className="animable"
          />
          <path
            d="M273.6,224.91a1.25,1.25,0,0,0-1.16,1.21s.12.8,1.25.75,1.17-.88,1.17-.88A1.3,1.3,0,0,0,273.6,224.91Z"
            style={{
              fill: "rgb(240, 153, 122)",
              transformOrigin: "273.65px 225.891px",
            }}
            id="elxsfgx09tiqo"
            className="animable"
          />
          <path
            d="M260.57,218s-.94-1.9-2.48-2.12a4.24,4.24,0,0,0-1.53,2.74,3.91,3.91,0,0,0-3.38.83,3.59,3.59,0,0,0,2.15,2.47,4.76,4.76,0,0,0,.11,3.52s3,.22,4-2.25c0,0,1.1,1.64,4.12,1.07a3.09,3.09,0,0,0-1.1-3.6s1.87-1.08,1.65-2.88A4.66,4.66,0,0,0,260.57,218Z"
            style={{
              fill: "rgb(250, 250, 250)",
              transformOrigin: "258.654px 220.663px",
            }}
            id="elmnbg6iaa7l"
            className="animable"
          />
          <path
            d="M258.85,219.16a1.93,1.93,0,0,0-1.81,1.75s.18,1.14,1.92,1.05,1.82-1.28,1.82-1.28A1.87,1.87,0,0,0,258.85,219.16Z"
            style={{
              fill: "rgb(240, 153, 122)",
              transformOrigin: "258.91px 220.561px",
            }}
            id="ellpf5l0r3xf8"
            className="animable"
          />
          <path
            d="M265.92,190s-.58-1.7-1.7-1.12-.73,1.65.25,1.9c0,0-2.09.68-1.51,1.79s2.38,0,2.77-.63c0,0,.39,1.71,1.84,1.1s0-2.07,0-2.07,2.24-.87,1-1.89S265.92,190,265.92,190Z"
            style={{
              fill: "rgb(250, 250, 250)",
              transformOrigin: "265.901px 190.965px",
            }}
            id="el8xvwii1cp0d"
            className="animable"
          />
          <path
            d="M277.34,215s-.58-1.7-1.7-1.12-.73,1.65.25,1.89c0,0-2.09.68-1.51,1.8s2.38-.05,2.77-.63c0,0,.39,1.71,1.84,1.1s0-2.08,0-2.08,2.24-.87,1-1.89S277.34,215,277.34,215Z"
            style={{
              fill: "rgb(250, 250, 250)",
              transformOrigin: "277.321px 215.965px",
            }}
            id="elj9ul1yr8g2d"
            className="animable"
          />
          <path
            d="M279.51,206.19s.17-1.79-1.09-1.72-1.34,1.2-.56,1.83c0,0-2.18-.25-2.11,1s2.19.94,2.78.57c0,0-.35,1.72,1.23,1.76s.86-1.89.86-1.89,2.39.14,1.7-1.3S279.51,206.19,279.51,206.19Z"
            style={{
              fill: "rgb(250, 250, 250)",
              transformOrigin: "279.097px 207.049px",
            }}
            id="el25g0qyf03lh"
            className="animable"
          />
          <path
            d="M264.56,210.8s.18-1.79-1.08-1.72-1.35,1.2-.56,1.82c0,0-2.19-.24-2.12,1s2.19.93,2.78.56c0,0-.35,1.72,1.23,1.77s.86-1.89.86-1.89,2.39.13,1.71-1.3S264.56,210.8,264.56,210.8Z"
            style={{
              fill: "rgb(250, 250, 250)",
              transformOrigin: "264.15px 211.654px",
            }}
            id="elku4eaeu7yh"
            className="animable"
          />
          <path
            d="M247.65,208s-1.44-1.91-.35-2.37,1.56,1.18,1.56,1.18,1.1-1.3,1.62-.37-.81,1.9-.81,1.9,1.5.81.64,1.62-1.91-.46-1.91-.46-.59,1.44-1.51,1S246.55,208.43,247.65,208Z"
            style={{
              fill: "rgb(250, 250, 250)",
              transformOrigin: "248.517px 208.066px",
            }}
            id="el4r2rtawjhk9"
            className="animable"
          />
        </g>
      </g>
    </g>
    <g
      id="freepik--Hearts--inject-63"
      className="animable animator-active"
      style={{
        transformOrigin: "251.998px 279.956px",
      }}
    >
      <path
        id="freepik--Heart--inject-63"
        d="M423,278.19a5.49,5.49,0,0,1,3.3-2.15h0a5.54,5.54,0,0,1,4.44.94c1.95,1.42,2.28,4.44,1.52,6.79-.07.24.14.58.29.47,2-1.53,5.11-2.21,7.1-.75a5.56,5.56,0,0,1,2.26,3.94v0h0a5.56,5.56,0,0,1-1,3.8c-2.59,3.55-7.31,3.11-11.76,3.42l-4.53,0-1.28-4.21C422.26,286.09,420.4,281.73,423,278.19Z"
        style={{
          fill: "#213E60",
          transformOrigin: "431.81px 285.282px",
        }}
        className="animable"
      />
      <path
        id="freepik--heart--inject-63"
        d="M63.63,281.6a5.19,5.19,0,0,1-1.56-3.34h0v0a5.22,5.22,0,0,1,1.45-4c1.57-1.62,4.41-1.53,6.49-.52.21.1.56-.05.47-.21-1.15-2.07-1.38-5,.24-6.68a5.17,5.17,0,0,1,4-1.58h0a5.21,5.21,0,0,1,3.39,1.46c3,2.86,1.92,7.18,1.64,11.35l-.63,4.19L75,282.9C70.87,283.31,66.58,284.47,63.63,281.6Z"
        style={{
          fill: "#213E60",
          transformOrigin: "71.1129px 274.372px",
        }}
        className="animable"
      />
    </g>
    <defs>
      <filter id="active" height="200%">
        <feMorphology
          in="SourceAlpha"
          result="DILATED"
          operator="dilate"
          radius={2}
        />
        <feFlood floodColor="#32DFEC" floodOpacity={1} result="PINK" />
        <feComposite in="PINK" in2="DILATED" operator="in" result="OUTLINE" />
        <feMerge>
          <feMergeNode in="OUTLINE" />
          <feMergeNode in="SourceGraphic" />
        </feMerge>
      </filter>
      <filter id="hover" height="200%">
        <feMorphology
          in="SourceAlpha"
          result="DILATED"
          operator="dilate"
          radius={2}
        />
        <feFlood floodColor="#ff0000" floodOpacity={0.5} result="PINK" />
        <feComposite in="PINK" in2="DILATED" operator="in" result="OUTLINE" />
        <feMerge>
          <feMergeNode in="OUTLINE" />
          <feMergeNode in="SourceGraphic" />
        </feMerge>
        <feColorMatrix
          type="matrix"
          values="0   0   0   0   0                0   1   0   0   0                0   0   0   0   0                0   0   0   1   0 "
        />
      </filter>
    </defs>
  </svg>
);
export default WeddingInvitaionSVG;
